<template>
  <div class="admin-page">
    <admin-page-header
      eyebrow="Kullanıcılar"
      title="Kullanıcı Listesi"
      description="Kullanıcı hesaplarını ve temel profil alanlarını mevcut backend akışını bozmadan yönetin."
    ></admin-page-header>

    <v-card
      class="admin-table-card"
      outlined
    >
      <v-alert
        v-if="tableError"
        dense
        outlined
        type="error"
        class="ma-4 mb-0"
      >
        {{ tableError }}
      </v-alert>

      <v-data-table
        dense
        :footer-props="{ itemsPerPageOptions: [20, 50, 100, -1] }"
        :server-items-length="totalElements"
        :page="params.page + 1"
        :items-per-page.sync="params.size"
        :loading="loading"
        loading-text="Yükleniyor"
        :headers="headers"
        :items="desserts"
        sort-by="registerDate"
        :sort-desc="true"
        class="admin-data-table elevation-0"
        @update:options="onUpdateTableOptions"
        @click:row="openUserDashboard"
      >
        <template v-slot:top>
          <div class="admin-table-toolbar user-list-toolbar">
            <div class="user-list-toolbar__meta">
              <div class="admin-table-toolbar__title">
                Kullanıcı kayıtları
              </div>
              <v-chip
                small
                outlined
                color="primary"
              >
                {{ totalElements }} toplam kayıt
              </v-chip>
            </div>

            <div class="user-list-toolbar__controls">
              <v-text-field
                v-model="searchValue"
                append-icon="mdi-magnify"
                label="Kullanıcı ara"
                placeholder="ID, ad, soyad, telefon veya e-posta"
                single-line
                hide-details
                outlined
                dense
                clearable
                class="user-list-search"
                @input="onSearch"
              ></v-text-field>

              <v-select
                v-model="params.userState"
                :items="userStateOptions"
                item-text="text"
                item-value="value"
                label="Durum"
                hide-details
                outlined
                dense
                class="user-list-filter"
                @change="onUserStateChange"
              ></v-select>

              <v-select
                v-model="params.reconciliationDeficit"
                :items="reconciliationFilterOptions"
                item-text="text"
                item-value="value"
                label="Mutabakat"
                hide-details
                outlined
                dense
                class="user-list-filter"
                @change="onReconciliationFilterChange"
              ></v-select>
            </div>
          </div>

          <v-dialog
            v-model="userDialog"
            persistent
            max-width="520px"
          >
            <user-delete-dialog
              :close="closeDialog"
              :save="deleteItem"
              :item="deleteItems"
            />
          </v-dialog>

          <v-dialog
            v-model="dialog"
            max-width="980px"
          >
            <v-card class="admin-dialog-card">
              <v-toolbar
                dense
                :elevation="0"
              >
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click="close"
                >
                  <v-icon>{{ icons.mdiClose }}</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.name"
                        outlined
                        dense
                        :rules="[rules.required]"
                        label="Ad"
                        placeholder="Ad"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.surname"
                        outlined
                        dense
                        :rules="[rules.required]"
                        label="Soyad"
                        placeholder="Soyad"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.email"
                        outlined
                        dense
                        :rules="[rules.required, rules.email]"
                        placeholder="john@example.com"
                        label="Email"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="editedIndex === -1"
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="editedItem.password"
                        outlined
                        dense
                        placeholder="••••••••••••"
                        :rules="editedIndex === -1 ? [rules.required] : []"
                        :append-icon="show ? icons.mdiEye : icons.mdiEyeOff"
                        :type="show ? 'text' : 'password'"
                        label="Şifre"
                        @click:append="show = !show"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        v-model="phone"
                        outlined
                        dense
                        :rules="[rules.required]"
                        placeholder="+90 (5xx) xxx xx xx"
                        label="Tel No"
                        maxlength="17"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="editedItem.birthDate"
                            outlined
                            dense
                            label="Doğum Tarihi"
                            persistent-hint
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <v-radio-group
                        v-model="editedItem.gender"
                        row
                      >
                        <v-radio
                          :value="true"
                          label="Kadın"
                        ></v-radio>
                        <v-radio
                          :value="false"
                          label="Erkek"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col
                      v-if="editedIndex !== -1"
                      cols="12"
                    >
                      <div class="admin-inline-field">
                        <span class="text-caption font-weight-bold">Kişi aktif / pasif durumu</span>
                        <span class="error--text">Pasif</span>
                        <v-switch
                          v-model="editedItem.active"
                          inset
                          @click="activeChange"
                        ></v-switch>
                        <span class="success--text">Aktif</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="close"
                >
                  Çık
                </v-btn>
                <v-btn
                  color="primary"
                  @click="handleSave(editedItem)"
                >
                  Kaydet
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.name="{ item }">
          <div class="user-list-user">
            <v-avatar
              size="34"
              color="primary"
              class="user-list-user__avatar"
            >
              <span class="white--text text-caption font-weight-bold">{{ getInitials(item) }}</span>
            </v-avatar>
            <div class="user-list-user__copy">
              <strong>{{ item.name }} {{ item.surname }}</strong>
              <span>#{{ item.id }}</span>
              <v-chip
                v-if="item.reconciliationDeficit"
                x-small
                outlined
                color="error"
                class="mt-1 align-self-start"
              >
                Mutabakat açığı
              </v-chip>
            </div>
          </div>
        </template>

        <template v-slot:item.reconciliationDeficitAmount="{ item }">
          <v-chip
            v-if="item.reconciliationDeficit"
            small
            color="error"
            outlined
          >
            {{ formatMoney(item.reconciliationDeficitAmount) }}
          </v-chip>
          <span v-else>-</span>
        </template>

        <template v-slot:item.birthDate="{ item }">
          <td>{{ item.birthDate ? item.birthDate : '-' }}</td>
        </template>

        <template v-slot:item.email="{ item }">
          <div class="user-list-email">
            {{ item.email }}
          </div>
        </template>

        <template v-slot:item.registerDate="{ item }">
          <td>{{ item.registerDate || '-' }}</td>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip
            small
            :color="userStatus(item).color"
            outlined
          >
            {{ userStatus(item).label }}
          </v-chip>
        </template>

        <template v-slot:item.action="{ item }">
          <div class="d-flex align-center">
            <v-btn
              icon
              small
              aria-label="Kullanıcı detayını aç"
              title="Kullanıcı detayını aç"
              @click.stop="openUserDashboard(item)"
            >
              <v-icon small>
                {{ icons.mdiEye }}
              </v-icon>
            </v-btn>
            <v-btn
              icon
              small
              color="primary"
              aria-label="Kullanıcıyı düzenle"
              title="Kullanıcıyı düzenle"
              @click.stop="editItem(item)"
            >
              <v-icon small>
                {{ icons.mdiPencil }}
              </v-icon>
            </v-btn>
            <v-menu offset-y>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  aria-label="Diğer kullanıcı işlemleri"
                  title="Diğer kullanıcı işlemleri"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>
                    {{ icons.mdiDotsVertical }}
                  </v-icon>
                </v-btn>
              </template><v-list dense>
                <v-list-item @click="openUserDelete(item)">
                  <v-list-item-title class="error--text">
                    Kullanıcıyı sil
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>

        <template v-slot:item.mobile="{ item }">
          <span>{{ displayPhone(item.mobile) }}</span>
        </template>
      </v-data-table>

      <v-dialog
        v-model="dashboardDialog"
        fullscreen
        scrollable
        content-class="user-dashboard-dialog-shell"
        @input="onDashboardVisibility"
      >
        <v-card class="admin-dialog-card user-dashboard-dialog user-dashboard-dialog--full">
          <v-toolbar
            dense
            :elevation="0"
          >
            <div class="user-dashboard-title">
              <v-avatar
                size="38"
                color="primary"
                class="mr-3"
              >
                <span class="white--text text-caption font-weight-bold">
                  {{ getInitials(dashboardProfile) }}
                </span>
              </v-avatar>
              <div>
                <v-toolbar-title>{{ dashboardProfile.fullName || 'Kullanıcı dashboard' }}</v-toolbar-title>
                <div class="user-dashboard-title__meta">
                  #{{ dashboardProfile.id || '-' }} · {{ dashboardProfile.email || '-' }}
                </div>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              small
              outlined
              color="primary"
              class="mr-3"
              :loading="dashboardLoading"
              :disabled="!dashboardUserId"
              @click="refreshUserDashboard"
            >
              <v-icon
                left
                small
              >
                {{ icons.mdiRefresh }}
              </v-icon>
              Yenile
            </v-btn>
            <v-btn
              icon
              aria-label="Kullanıcı detayını kapat"
              title="Detayı kapat"
              @click="closeUserDashboard"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="user-dashboard-dialog__body">
            <v-alert
              v-if="dashboardError"
              dense
              outlined
              type="error"
              class="mb-4"
            >
              {{ dashboardError }}
            </v-alert>

            <v-progress-linear
              v-if="dashboardLoading"
              indeterminate
              color="primary"
              class="mb-4"
            ></v-progress-linear>

            <template v-if="dashboard">
              <v-alert
                v-if="dashboardWallet.reconciliationDeficit"
                dense
                outlined
                type="error"
                class="mb-4"
              >
                Bu kullanıcının {{ formatMoney(dashboardWallet.reconciliationDeficitAmount) }} mutabakat açığı var.
                Açık kapanana kadar yeni para çekme talebi oluşturulamaz.
              </v-alert>

              <div class="user-dashboard-summary-grid">
                <div
                  v-for="card in dashboardSummaryCards"
                  :key="card.label"
                  class="user-dashboard-summary-card"
                >
                  <span>{{ card.label }}</span>
                  <strong>{{ card.value }}</strong>
                  <small>{{ card.caption }}</small>
                </div>
              </div>

              <user-activity-summary
                :dashboard="dashboard"
                @select-tab="dashboardTab = $event"
              />
              <v-tabs
                v-model="dashboardTab"
                show-arrows
                class="user-dashboard-tabs"
              >
                <v-tab>Linkler</v-tab>
                <v-tab>Puan</v-tab>
                <v-tab>Mutabakat Geçmişi</v-tab>
                <v-tab>Cüzdan İşlemleri</v-tab>
                <v-tab>Analytics</v-tab>
                <v-tab>Bildirimler</v-tab>
                <v-tab>Mailler</v-tab>
                <v-tab>Para Çekme</v-tab>
                <v-tab>Profil</v-tab>
                <v-tab>Premium</v-tab>
              </v-tabs>

              <v-tabs-items v-model="dashboardTab">
                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardLinkHeaders"
                    :items="dashboard.links || []"
                    :items-per-page="10"
                    item-key="id"
                    show-expand
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.name="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.name || '-' }}</strong>
                        <span>{{ item.uniqueId || '-' }}</span>
                        <v-chip
                          v-if="item.selfPurchase"
                          x-small
                          outlined
                          color="primary"
                          class="user-dashboard-self-link-chip"
                        >
                          Self Link
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:item.campaignName="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.sourceCampaignName || item.campaignName || '-' }}</strong>
                        <span v-if="item.selfPurchase && item.sourceCampaignName">Kaynak kampanya</span>
                      </div>
                    </template>
                    <template v-slot:item.viewerLink="{ item }">
                      <a
                        v-if="item.viewerLink"
                        :href="item.viewerLink"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Aç
                      </a>
                      <span v-else>-</span>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="dashboardStatusColor(item.status)"
                      >
                        {{ formatDashboardStatus(item.status) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.created="{ item }">
                      {{ formatDateTime(item.created) }}
                    </template>
                    <template v-slot:item.payout="{ item }">
                      {{ formatMoney(item.payout) }}
                    </template>
                    <template v-slot:item.expectedEarning="{ item }">
                      {{ formatMoney(item.expectedEarning) }}
                    </template>
                    <template v-slot:item.confirmedEarning="{ item }">
                      {{ formatMoney(item.confirmedEarning) }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        class="user-dashboard-link-expanded"
                      >
                        <div class="user-dashboard-link-detail">
                          <div class="user-dashboard-link-detail-grid">
                            <div class="user-dashboard-link-detail-card">
                              <span>Snapshot güncelleme</span>
                              <strong>{{ formatDateTime(item.lastSnapshotAt) }}</strong>
                            </div>
                            <div class="user-dashboard-link-detail-card">
                              <span>Click</span>
                              <strong>{{ item.click || 0 }}</strong>
                            </div>
                            <div class="user-dashboard-link-detail-card">
                              <span>Suspicious click</span>
                              <strong>{{ item.suspiciousClick || 0 }}</strong>
                            </div>
                            <div class="user-dashboard-link-detail-card">
                              <span>Satış</span>
                              <strong>{{ item.sales || item.conversion || 0 }}</strong>
                            </div>
                            <div class="user-dashboard-link-detail-card">
                              <span>Hakediş</span>
                              <strong>{{ formatMoney(item.confirmedEarning) }}</strong>
                            </div>
                          </div>

                          <div class="user-dashboard-link-transactions-title">
                            Linke bağlı son işlemler
                          </div>
                          <v-simple-table
                            v-if="item.recentTransactions && item.recentTransactions.length"
                            dense
                            class="user-dashboard-link-transactions"
                          >
                            <thead>
                              <tr>
                                <th>Tarih</th>
                                <th>Transaction</th>
                                <th title="Provider satış kalemi kimliği">
                                  Event ID
                                </th>
                                <th>Durum</th>
                                <th>Kullanıcı görünürlüğü</th>
                                <th>Tutar</th>
                                <th>Satış Tutarı</th>
                                <th>Not</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="transaction in item.recentTransactions"
                                :key="transaction.id"
                              >
                                <td>{{ formatDateTime(transaction.entryDate) }}</td>
                                <td>{{ transaction.transactionId || transaction.uniqueId || '-' }}</td>
                                <td>{{ transaction.providerEventId || '-' }}</td>
                                <td>{{ formatDashboardStatus(transaction.status) }}</td>
                                <td>{{ transaction.userVisible ? 'Görünür' : 'Gizli' }}</td>
                                <td>{{ formatMoney(transaction.amount) }}</td>
                                <td>{{ formatMoney(transaction.saleAmount) }}</td>
                                <td>{{ transaction.note || '-' }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                          <div
                            v-else
                            class="user-dashboard-empty-note"
                          >
                            Bu link için cüzdan işlemi bulunmuyor.
                          </div>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <div class="user-dashboard-point-overview">
                    <div
                      v-for="card in dashboardPointDetailCards"
                      :key="card.label"
                      class="user-dashboard-point-card"
                    >
                      <span>{{ card.label }}</span>
                      <strong>{{ card.value }}</strong>
                      <small>{{ card.caption }}</small>
                    </div>
                  </div>

                  <div class="user-dashboard-point-grid">
                    <section class="user-dashboard-point-section">
                      <div class="user-dashboard-point-section__header">
                        <h3>Puan Detayları</h3>
                        <span>{{ dashboardPointBucketRows.length }} sepet</span>
                      </div>
                      <v-simple-table
                        v-if="dashboardPointBucketRows.length"
                        dense
                        class="user-dashboard-point-simple-table"
                      >
                        <thead>
                          <tr>
                            <th>Sepet</th>
                            <th>Cüzdan</th>
                            <th>Puan</th>
                            <th>TRY</th>
                            <th>APR</th>
                            <th>Kilit</th>
                            <th>Premium</th>
                            <th>Son hareket</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="bucket in dashboardPointBucketRows"
                            :key="bucket.id"
                          >
                            <td>
                              <div class="user-dashboard-primary-cell">
                                <strong>{{ bucket.bucketLabel || bucket.bucketKey || '-' }}</strong>
                                <span>{{ bucket.bucketKey || bucket.id || '-' }}</span>
                              </div>
                            </td>
                            <td>{{ formatPointBucketType(bucket.subWalletType || bucket.type) }}</td>
                            <td>{{ formatPoints(bucket.points, false) }}</td>
                            <td>{{ formatMoney(bucket.tryValue) }}</td>
                            <td>{{ formatApr(bucket.apr) }}</td>
                            <td>{{ bucket.lockDays ? `${bucket.lockDays} gün` : '-' }}</td>
                            <td>{{ bucket.premium ? 'Premium' : 'Standart' }}</td>
                            <td>{{ formatDateTime(bucket.lastEffectiveAt) }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                      <div
                        v-else
                        class="user-dashboard-empty-note"
                      >
                        Kullanıcıya ait aktif puan sepeti bulunmuyor.
                      </div>
                    </section>

                    <section class="user-dashboard-point-section">
                      <div class="user-dashboard-point-section__header">
                        <h3>Çevirim/Kota ve APR</h3>
                        <span>{{ dashboardPointAprPreview ? formatPointAccessTier(dashboardPointAprPreview.currentAccessTier) : 'Snapshot yok' }}</span>
                      </div>
                      <template v-if="dashboardPointAprPreview">
                        <div class="user-dashboard-apr-cards">
                          <div class="user-dashboard-apr-card">
                            <span>Tier-1 Kota</span>
                            <strong>{{ formatPoints(dashboardPointAprPreview.tier1EligiblePoints, false) }}</strong>
                            <small>{{ formatMoney(dashboardPointAprPreview.tier1EligibleTryValue) }}</small>
                          </div>
                          <div class="user-dashboard-apr-card">
                            <span>Kalan Kota</span>
                            <strong>{{ formatPoints(dashboardPointAprPreview.tier1RemainingEligiblePoints, false) }}</strong>
                            <small>{{ formatMoney(dashboardPointAprPreview.tier1RemainingTryValue) }}</small>
                          </div>
                          <div class="user-dashboard-apr-card">
                            <span>Aktif Esnek Tier-2 APR</span>
                            <strong>{{ formatApr(dashboardPointAprPreview.activeFlexibleTier2Apr) }}</strong>
                            <small>{{ dashboardPointAprPreview.previewMode || '-' }}</small>
                          </div>
                          <div class="user-dashboard-apr-card">
                            <span>Skor</span>
                            <strong>{{ dashboardPointAprPreview.score || 0 }}</strong>
                            <small>{{ dashboardPointAprPreview.eligibilityBucket || '-' }}</small>
                          </div>
                        </div>
                        <p class="user-dashboard-apr-summary">
                          {{ dashboardPointAprPreview.summary || '-' }}
                        </p>
                        <v-simple-table
                          v-if="dashboardPointAprTierRows.length"
                          dense
                          class="user-dashboard-point-simple-table"
                        >
                          <thead>
                            <tr>
                              <th>Bucket</th>
                              <th>Kilit</th>
                              <th>Standart Tier-2 APR</th>
                              <th>Premium Tier-2 APR</th>
                              <th>Standart Tier-2 Bant</th>
                              <th>Premium Tier-2 Bant</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="tier in dashboardPointAprTierRows"
                              :key="tier.bucketId"
                            >
                              <td>{{ tier.label || tier.bucketId || '-' }}</td>
                              <td>{{ tier.lockDays ? `${tier.lockDays} gün` : 'Esnek' }}</td>
                              <td>{{ formatApr(tier.standardApr) }}</td>
                              <td>{{ formatApr(tier.premiumApr) }}</td>
                              <td>{{ formatAprRange(tier.standardFloorApr, tier.standardCeilingApr) }}</td>
                              <td>{{ formatAprRange(tier.premiumFloorApr, tier.premiumCeilingApr) }}</td>
                            </tr>
                          </tbody>
                        </v-simple-table>
                        <div
                          v-if="dashboardPointAprPreview.gateReasons && dashboardPointAprPreview.gateReasons.length"
                          class="user-dashboard-apr-notes"
                        >
                          <strong>Blok / gate nedenleri</strong>
                          <span
                            v-for="reason in dashboardPointAprPreview.gateReasons"
                            :key="reason"
                          >
                            {{ reason }}
                          </span>
                        </div>
                      </template>
                      <div
                        v-else
                        class="user-dashboard-empty-note"
                      >
                        Bu kullanıcı için APR/kota preview üretilemedi.
                      </div>
                    </section>
                  </div>

                  <section
                    v-if="dashboardPointLockRows.length"
                    class="user-dashboard-point-section user-dashboard-point-section--locks"
                  >
                    <div class="user-dashboard-point-section__header">
                      <h3>Aktif Kilitler</h3>
                      <span>{{ dashboardPointLockRows.length }} kayıt</span>
                    </div>
                    <v-simple-table
                      dense
                      class="user-dashboard-point-simple-table"
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Sepet</th>
                          <th>Ana Puan</th>
                          <th>Kilitli</th>
                          <th>Kazanılan Ödül</th>
                          <th>Bozulan Ödül</th>
                          <th>APR</th>
                          <th>Başlangıç</th>
                          <th>Bitiş</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="lock in dashboardPointLockRows"
                          :key="lock.id"
                        >
                          <td>#{{ lock.id }}</td>
                          <td>{{ lock.bucketLabel || lock.bucketKey || '-' }}</td>
                          <td>{{ formatPoints(lock.principalAmount, false) }}</td>
                          <td>{{ formatPoints(lock.currentLockedAmount, false) }}</td>
                          <td>{{ formatPoints(lock.releasedRewardAmount, false) }}</td>
                          <td>{{ formatPoints(lock.reversedRewardAmount, false) }}</td>
                          <td>{{ formatApr(lock.apr) }}</td>
                          <td>{{ formatDateTime(lock.lockedAt) }}</td>
                          <td>{{ formatDateTime(lock.unlockAt) }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </section>

                  <h3 class="user-dashboard-section-title">
                    Puan İşlemleri
                  </h3>
                  <v-data-table
                    dense
                    :headers="dashboardPointHeaders"
                    :items="dashboard.pointTransactions || []"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.description="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.description || item.referenceType || '-' }}</strong>
                        <span>İşlem Kimliği: {{ formatPointTransactionIdentity(item) }}</span>
                      </div>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="dashboardStatusColor(item.status)"
                      >
                        {{ formatDashboardStatus(item.status) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.amount="{ item }">
                      {{ formatPoints(item.amount, true) }}
                    </template>
                    <template v-slot:item.tryValue="{ item }">
                      {{ formatMoney(item.tryValue) }}
                    </template>
                    <template v-slot:item.effectiveAt="{ item }">
                      {{ formatDateTime(item.effectiveAt) }}
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardReconciliationHeaders"
                    :items="dashboard.walletTransitions || []"
                    :items-per-page="25"
                    :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.statusTransition="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>
                          {{ formatDashboardStatus(item.fromStatus) }} → {{ formatDashboardStatus(item.toStatus) }}
                        </strong>
                        <span>Entry #{{ item.entryId || '-' }} · Link #{{ item.linkId || '-' }}</span>
                      </div>
                    </template>
                    <template v-slot:item.amountTransition="{ item }">
                      {{ formatMoney(item.oldAmount) }} → {{ formatMoney(item.newAmount) }}
                    </template>
                    <template v-slot:item.reason="{ item }">
                      {{ formatReconciliationReason(item.reason) }}
                    </template>
                    <template v-slot:item.observed="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ formatDashboardStatus(item.observedStatus) }}</strong>
                        <span>Raw: {{ item.observedStatusRaw || '-' }}</span>
                        <span>Gözlem: {{ formatDateTime(item.observedAt) }}</span>
                      </div>
                    </template>
                    <template v-slot:item.missingObservation="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.missingObservationCount || 0 }} gözlem</strong>
                        <span>İlk: {{ formatDateTime(item.firstMissingAt) }}</span>
                        <span>Son: {{ formatDateTime(item.lastMissingAt) }}</span>
                      </div>
                    </template>
                    <template v-slot:item.notificationStatus="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.notificationTitle || '-' }}</strong>
                        <span>{{ formatNotificationDispatchStatus(item.notificationStatus) }}</span>
                      </div>
                    </template>
                    <template v-slot:item.systemAt="{ item }">
                      {{ formatDateTime(item.systemAt) }}
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardWalletHeaders"
                    :items="dashboard.walletTransactions || []"
                    :items-per-page="25"
                    item-key="id"
                    show-expand
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.linkName="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.linkName || item.campaignName || '-' }}</strong>
                        <span>{{ item.transactionId || item.uniqueId || '-' }}</span>
                      </div>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="dashboardStatusColor(item.status)"
                      >
                        {{ formatDashboardStatus(item.status) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.userVisible="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="item.userVisible ? 'success' : 'warning'"
                      >
                        {{ item.userVisible ? 'Görünür' : 'Gizli' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.entryDate="{ item }">
                      {{ formatDateTime(item.entryDate) }}
                    </template>
                    <template v-slot:item.amount="{ item }">
                      {{ formatMoney(item.amount) }}
                    </template>
                    <template v-slot:item.saleAmount="{ item }">
                      {{ formatMoney(item.saleAmount) }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        class="user-dashboard-link-expanded"
                      >
                        <div class="user-dashboard-detail-panel">
                          <div
                            v-for="row in dashboardWalletDetailRows(item)"
                            :key="row.label"
                            class="user-dashboard-detail-item"
                          >
                            <span>{{ row.label }}</span>
                            <strong>{{ row.value }}</strong>
                          </div>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardAnalyticsHeaders"
                    :items="dashboard.analyticsEvents || []"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.eventName="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.eventName || '-' }}</strong>
                        <span>{{ item.screenName || '-' }}</span>
                      </div>
                    </template>
                    <template v-slot:item.eventType="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="analyticsTypeColor(item.eventType)"
                      >
                        {{ item.eventType || '-' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.target="{ item }">
                      {{ formatAnalyticsTarget(item) }}
                    </template>
                    <template v-slot:item.propertiesJson="{ item }">
                      <span class="user-dashboard-json-preview">{{ formatJsonPreview(item.propertiesJson) }}</span>
                    </template>
                    <template v-slot:item.occurredAt="{ item }">
                      {{ formatDateTime(item.occurredAt) }}
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardNotificationHeaders"
                    :items="dashboard.notifications || []"
                    :items-per-page="25"
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.title="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.title || '-' }}</strong>
                        <span>{{ item.message || '-' }}</span>
                      </div>
                    </template>
                    <template v-slot:item.audience="{ item }">
                      {{ formatNotificationAudience(item) }}
                    </template>
                    <template v-slot:item.send="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="item.send ? 'success' : 'primary'"
                      >
                        {{ item.send ? 'Gönderildi' : 'Gönderilmedi' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.date="{ item }">
                      {{ formatDateTime(item.date || item.created) }}
                    </template>
                    <template v-slot:item.scheduled="{ item }">
                      {{ item.scheduled ? 'Planlı' : 'Anlık' }}
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <v-alert
                    v-if="dashboardMailError"
                    dense
                    outlined
                    type="error"
                    class="mb-3"
                  >
                    {{ dashboardMailError }}
                  </v-alert>

                  <div class="user-dashboard-mail-toolbar">
                    <v-select
                      v-model="dashboardMailRangeDays"
                      :items="dashboardMailRangeOptions"
                      dense
                      outlined
                      hide-details
                      label="Tarih aralığı"
                      class="user-dashboard-mail-filter"
                      @change="applyDashboardMailFilters"
                    ></v-select>
                    <v-select
                      v-model="dashboardMailStatus"
                      :items="dashboardMailStatusOptions"
                      dense
                      outlined
                      hide-details
                      label="Teslimat durumu"
                      class="user-dashboard-mail-filter"
                      @change="applyDashboardMailFilters"
                    ></v-select>
                    <v-spacer></v-spacer>
                    <span class="text-caption text--secondary">
                      {{ dashboardMailTotal }} mail · Türkiye saati (UTC+3)
                    </span>
                  </div>

                  <v-data-table
                    dense
                    :headers="dashboardMailHeaders"
                    :items="dashboardMails"
                    :items-per-page="dashboardMailPageSize"
                    :loading="dashboardMailLoading"
                    loading-text="Mailler yükleniyor"
                    hide-default-footer
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.id="{ item }">
                      #{{ item.id }}
                    </template>
                    <template v-slot:item.message="{ item }">
                      <div class="user-dashboard-primary-cell">
                        <strong>{{ item.messageName || formatMailMessageName(item.messageKey) }}</strong>
                        <span>{{ item.messageKey || '-' }}</span>
                        <span v-if="item.campaignName">{{ item.campaignName }}</span>
                      </div>
                    </template>
                    <template v-slot:item.recipient="{ item }">
                      <div class="user-dashboard-mail-recipient">
                        <strong>{{ item.email || item.maskedEmail || '-' }}</strong>
                        <span>{{ formatMailSource(item.sourceType) }}</span>
                      </div>
                    </template>
                    <template v-slot:item.provider="{ item }">
                      <v-chip
                        x-small
                        outlined
                        color="primary"
                      >
                        {{ item.provider || '-' }}
                      </v-chip>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        x-small
                        outlined
                        :color="mailStatusColor(item.status)"
                      >
                        {{ formatMailStatus(item.status) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                      {{ formatMailDateTime(item.createdAt) }}
                    </template>
                    <template v-slot:item.resultAt="{ item }">
                      {{ formatMailResultTime(item) }}
                    </template>
                    <template v-slot:item.events="{ item }">
                      <v-btn
                        x-small
                        outlined
                        color="primary"
                        @click="openDashboardMailEvents(item)"
                      >
                        Eventler
                      </v-btn>
                    </template>
                  </v-data-table>

                  <div class="user-dashboard-mail-pagination">
                    <span class="text-caption text--secondary">
                      Sayfa {{ dashboardMailPage + 1 }} / {{ Math.max(dashboardMailTotalPages, 1) }}
                    </span>
                    <div>
                      <v-btn
                        small
                        outlined
                        color="primary"
                        class="mr-2"
                        :disabled="dashboardMailPage <= 0 || dashboardMailLoading"
                        @click="goToDashboardMailPage(dashboardMailPage - 1)"
                      >
                        Önceki
                      </v-btn>
                      <v-btn
                        small
                        outlined
                        color="primary"
                        :disabled="dashboardMailPage + 1 >= dashboardMailTotalPages || dashboardMailLoading"
                        @click="goToDashboardMailPage(dashboardMailPage + 1)"
                      >
                        Sonraki
                      </v-btn>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item>
                  <v-data-table
                    dense
                    :headers="dashboardWithdrawHeaders"
                    :items="dashboard.withdrawRequests || []"
                    :items-per-page="25"
                    item-key="id"
                    show-expand
                    :footer-props="{ itemsPerPageOptions: [10, 20, 50, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        small
                        outlined
                        :color="dashboardStatusColor(item.status)"
                      >
                        {{ formatDashboardStatus(item.status) }}
                      </v-chip>
                    </template>
                    <template v-slot:item.requestedAt="{ item }">
                      {{ formatDateTime(item.requestedAt) }}
                    </template>
                    <template v-slot:item.requestAmount="{ item }">
                      {{ formatMoney(item.requestAmount) }}
                    </template>
                    <template v-slot:item.netAmount="{ item }">
                      {{ formatMoney(item.netAmount) }}
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        class="user-dashboard-link-expanded"
                      >
                        <div class="user-dashboard-detail-panel user-dashboard-detail-panel--wide">
                          <div
                            v-for="row in dashboardWithdrawDetailRows(item)"
                            :key="row.label"
                            class="user-dashboard-detail-item"
                          >
                            <span>{{ row.label }}</span>
                            <strong>{{ row.value }}</strong>
                          </div>
                        </div>
                      </td>
                    </template>
                  </v-data-table>
                </v-tab-item>

                <v-tab-item>
                  <div class="user-dashboard-profile-grid">
                    <div
                      v-for="row in dashboardProfileRows"
                      :key="row.label"
                      class="user-dashboard-profile-item"
                    >
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                  </div>

                  <h3 class="user-dashboard-section-title">
                    Fatura bilgileri
                  </h3>
                  <div
                    v-if="dashboardInvoiceRows.length"
                    class="user-dashboard-profile-grid user-dashboard-profile-grid--section"
                  >
                    <div
                      v-for="row in dashboardInvoiceRows"
                      :key="row.label"
                      class="user-dashboard-profile-item"
                    >
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                  </div>
                  <div
                    v-else
                    class="user-dashboard-profile-empty"
                  >
                    Kayıtlı fatura bilgisi yok.
                  </div>

                  <company-invoice-documents
                    v-if="dashboardInvoiceInfo && dashboardInvoiceInfo.invoiceTypeCompany === 'COMPANY'"
                    :key="dashboardUserId"
                    :user-id="dashboardUserId"
                    :headers="authHeaders()"
                  ></company-invoice-documents>
                  <h3 class="user-dashboard-section-title">
                    20/B istisna belgesi
                  </h3>
                  <v-card
                    class="pa-4"
                    outlined
                  >
                    <v-progress-linear
                      v-if="dashboardTaxDocumentLoading"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                    <v-alert
                      v-else-if="dashboardTaxDocumentError"
                      dense
                      outlined
                      type="error"
                      class="mb-0"
                    >
                      {{ dashboardTaxDocumentError }}
                      <v-btn
                        text
                        small
                        color="primary"
                        @click="loadDashboardTaxDocument"
                      >
                        Tekrar dene
                      </v-btn>
                    </v-alert>
                    <div v-else-if="dashboardTaxDocument">
                      <div class="d-flex align-start justify-space-between flex-wrap">
                        <div>
                          <div class="font-weight-bold">
                            {{ dashboardTaxDocument.originalFileName || '20/B istisna belgesi' }}
                          </div>
                          <div class="text-caption text--secondary mt-1">
                            Sürüm {{ dashboardTaxDocument.version || '-' }} ·
                            {{ formatDashboardTaxDocumentBytes(dashboardTaxDocument.sizeBytes) }} ·
                            {{ formatDateTime(dashboardTaxDocument.createdAt) }}
                          </div>
                        </div>
                        <v-chip
                          small
                          outlined
                          :color="dashboardTaxDocumentStatusColor(dashboardTaxDocument.status)"
                        >
                          {{ dashboardTaxDocumentStatusLabel(dashboardTaxDocument.status) }}
                        </v-chip>
                      </div>
                      <v-alert
                        v-if="dashboardTaxDocument.rejectReason"
                        dense
                        outlined
                        type="error"
                        class="mt-3 mb-0"
                      >
                        Geçersiz sayma sebebi: {{ dashboardTaxDocument.rejectReason }}
                      </v-alert>
                      <v-alert
                        dense
                        outlined
                        type="info"
                        class="mt-3 mb-0"
                      >
                        Bu kullanıcı seviyesindeki geçerlilik kararı fatura bilgileri, banka veya IBAN değişse de korunur.
                      </v-alert>
                      <v-alert
                        v-if="dashboardTaxDocumentReviewError"
                        dense
                        outlined
                        type="error"
                        class="mt-3 mb-0"
                      >
                        {{ dashboardTaxDocumentReviewError }}
                      </v-alert>
                      <div
                        class="d-flex align-center flex-wrap mt-3"
                        style="gap: 8px"
                      >
                        <v-btn
                          v-if="dashboardTaxDocument.contentAvailable"
                          small
                          outlined
                          color="primary"
                          :disabled="dashboardTaxDocumentReviewLoading"
                          @click="dashboardTaxDocumentPreviewOpen = true"
                        >
                          Belgeyi görüntüle
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="dashboardTaxDocument.status === 'PENDING_REVIEW'"
                          small
                          outlined
                          color="success"
                          :loading="dashboardTaxDocumentReviewAction === 'approve'"
                          :disabled="dashboardTaxDocumentReviewLoading"
                          @click="reviewDashboardTaxDocument('APPROVE')"
                        >
                          Geçerli
                        </v-btn>
                        <v-btn
                          v-if="dashboardTaxDocument.status === 'PENDING_REVIEW'"
                          small
                          outlined
                          color="error"
                          :disabled="dashboardTaxDocumentReviewLoading"
                          @click="openDashboardTaxDocumentInvalidDialog"
                        >
                          Geçersiz
                        </v-btn>
                      </div>
                    </div>
                    <div
                      v-else
                      class="user-dashboard-profile-empty"
                    >
                      Kullanıcının yüklediği 20/B istisna belgesi yok.
                    </div>
                  </v-card>

                  <h3 class="user-dashboard-section-title">
                    İlgi alanları
                  </h3>
                  <div
                    v-if="dashboardInterests.length"
                    class="user-dashboard-interests"
                  >
                    <v-chip
                      v-for="interest in dashboardInterests"
                      :key="interest.id || interest.name"
                      small
                      outlined
                      color="primary"
                    >
                      {{ interest.name || `İlgi alanı #${interest.id}` }}
                    </v-chip>
                  </div>
                  <div
                    v-else
                    class="user-dashboard-profile-empty"
                  >
                    İlgi alanı seçilmemiş.
                  </div>

                  <h3 class="user-dashboard-section-title">
                    Banka hesapları
                  </h3>
                  <v-data-table
                    dense
                    :headers="dashboardBankHeaders"
                    :items="dashboard.bankAccounts || []"
                    :items-per-page="5"
                    :footer-props="{ itemsPerPageOptions: [5, 10, 20, -1] }"
                    class="admin-data-table user-dashboard-table elevation-0"
                  ></v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <div v-if="dashboardPremium.premiumUserId">
                    <div class="user-dashboard-profile-grid user-dashboard-profile-grid--section">
                      <div
                        v-for="row in dashboardPremiumRows"
                        :key="row.label"
                        class="user-dashboard-profile-item"
                      >
                        <span>{{ row.label }}</span>
                        <strong>{{ row.value }}</strong>
                      </div>
                    </div>
                    <premium-lifecycle-timeline
                      :key="dashboardPremium.premiumUserId"
                      :premium-user-id="dashboardPremium.premiumUserId"
                      :active="dashboardDialog && dashboardTab === 9"
                    ></premium-lifecycle-timeline>
                  </div>
                  <div
                    v-else
                    class="user-dashboard-profile-empty"
                  >
                    Bu kullanıcıya bağlı premium kaydı bulunmuyor.
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dashboardTaxDocumentInvalidDialog"
        max-width="560"
        persistent
      >
        <v-card class="admin-dialog-card">
          <v-card-title>İstisna belgesini geçersiz işaretle</v-card-title>
          <v-card-text>
            <v-alert
              dense
              outlined
              type="warning"
            >
              Belge geçersiz sayılır ve bu belgeye bağlı tüm bekleyen para çekme talepleri reddedilir.
            </v-alert>
            <v-textarea
              v-model="dashboardTaxDocumentRejectReason"
              label="Geçersiz Sayma Sebebi"
              :counter="500"
              maxlength="500"
              outlined
              rows="3"
              auto-grow
            ></v-textarea>
            <v-alert
              v-if="dashboardTaxDocumentReviewError"
              dense
              outlined
              type="error"
              class="mb-0"
            >
              {{ dashboardTaxDocumentReviewError }}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="dashboardTaxDocumentReviewLoading"
              @click="closeDashboardTaxDocumentInvalidDialog"
            >
              Vazgeç
            </v-btn>
            <v-btn
              color="error"
              :loading="dashboardTaxDocumentReviewLoading"
              :disabled="dashboardTaxDocumentReviewLoading"
              @click="reviewDashboardTaxDocument('REJECT')"
            >
              Geçersiz Say
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dashboardMailEventDialog"
        max-width="920"
        scrollable
      >
        <v-card class="admin-dialog-card">
          <v-card-title>
            Mail eventleri
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="closeDashboardMailEvents"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle v-if="dashboardSelectedMail">
            #{{ dashboardSelectedMail.id }} ·
            {{ dashboardSelectedMail.messageName || formatMailMessageName(dashboardSelectedMail.messageKey) }} ·
            {{ dashboardSelectedMail.email || dashboardSelectedMail.maskedEmail || '-' }}
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-alert
            v-if="dashboardMailEventError"
            dense
            outlined
            type="error"
            class="ma-4 mb-0"
          >
            {{ dashboardMailEventError }}
          </v-alert>
          <v-data-table
            dense
            :headers="dashboardMailEventHeaders"
            :items="dashboardMailEvents"
            :loading="dashboardMailEventLoading"
            :items-per-page="25"
            :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
            class="admin-data-table elevation-0"
          >
            <template v-slot:item.event="{ item }">
              <div class="user-dashboard-primary-cell">
                <strong>{{ formatMailEventType(item.eventType) }}</strong>
                <span>{{ item.eventSubtype || '-' }}</span>
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              {{ formatMailStatus(item.status) }}
            </template>
            <template v-slot:item.occurredAt="{ item }">
              {{ formatMailDateTime(item.occurredAt) }}
            </template>
            <template v-slot:item.error="{ item }">
              <div class="user-dashboard-mail-error">
                <strong>{{ item.errorCode || '-' }}</strong>
                <span>{{ item.errorMessage || '-' }}</span>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
    </v-card>
    <tax-document-preview
      v-if="dashboardTaxDocumentPreviewOpen && dashboardTaxDocument"
      :key="`${dashboardUserId}-${dashboardTaxDocument.id}`"
      :document-id="dashboardTaxDocument.id"
      :headers="authHeaders()"
      @close="dashboardTaxDocumentPreviewOpen = false"
    ></tax-document-preview>
  </div>
</template>

<script>
import axios from 'axios'
import {
  mdiDelete, mdiPencil, mdiEye, mdiEyeOff, mdiClose, mdiRefresh, mdiDotsVertical,
} from '@mdi/js'
import moment from 'moment'
import { getAccessToken } from '@/utils/panelSession'
import AdminPageHeader from '@/components/admin/AdminPageHeader.vue'
import UserActivitySummary from '@/components/admin/UserActivitySummary.vue'
import TaxDocumentPreview from '@/components/admin/TaxDocumentPreview.vue'
import CompanyInvoiceDocuments from '@/components/admin/CompanyInvoiceDocuments.vue'
import { isAuthError, resolveApiErrorMessage } from '@/utils/apiErrors'
import serializeParams from '@/utils/httpParams'
import UserDeleteDialog from './UserDeleteDialog.vue'
import PremiumLifecycleTimeline from '@/views/premium/PremiumLifecycleTimeline.vue'
import walletTransactionDetailRows from '@/utils/walletTransactionDetails'
import phoneNumberUtils from '@/utils/phoneNumberutils'

export default {
  components: {
    UserActivitySummary,
    AdminPageHeader,
    TaxDocumentPreview,
    CompanyInvoiceDocuments,
    UserDeleteDialog,
    PremiumLifecycleTimeline,
  },
  data: () => ({
    searchValue: '',
    searchTimeout: null,
    tableError: '',
    dialog: false,
    show: false,
    loading: false,
    dashboardDialog: false,
    dashboardLoading: false,
    dashboardError: '',
    dashboard: null,
    dashboardUserId: null,
    dashboardRequest: 0,
    dashboardMailRequest: 0,
    dashboardTab: 0,
    dashboardTaxDocumentLoading: false,
    dashboardTaxDocumentRequestSerial: 0,
    dashboardTaxDocumentError: '',
    dashboardTaxDocument: null,
    dashboardTaxDocumentPreviewOpen: false,
    dashboardTaxDocumentReviewLoading: false,
    dashboardTaxDocumentReviewAction: '',
    dashboardTaxDocumentReviewError: '',
    dashboardTaxDocumentInvalidDialog: false,
    dashboardTaxDocumentRejectReason: '',
    dashboardMailLoading: false,
    dashboardMailError: '',
    dashboardMails: [],
    dashboardMailPage: 0,
    dashboardMailPageSize: 25,
    dashboardMailTotal: 0,
    dashboardMailTotalPages: 0,
    dashboardMailRangeDays: 90,
    dashboardMailStatus: '',
    dashboardMailEventDialog: false,
    dashboardMailEventLoading: false,
    dashboardMailEventError: '',
    dashboardMailEvents: [],
    dashboardSelectedMail: null,
    headers: [
      {
        text: 'Kullanıcı', align: 'left', sortable: true, value: 'name',
      },
      { text: 'E-posta', value: 'email', sortable: true },
      { text: 'Cep Telefonu', value: 'mobile' },
      { text: 'Kayıt Tarihi', value: 'registerDate', sortable: true },
      { text: 'Doğum Tarihi', value: 'birthDate', sortable: false },
      { text: 'Durum', value: 'active', sortable: true },
      { text: 'Mutabakat Açığı', value: 'reconciliationDeficitAmount', sortable: false },
      { text: 'İşlemler', value: 'action', sortable: false },
    ],
    dashboardLinkHeaders: [
      { text: 'Link adı', value: 'name', sortable: true },
      { text: 'Durum', value: 'status', sortable: true },
      { text: 'Kampanya', value: 'campaignName', sortable: true },
      { text: 'Marka / Offer', value: 'offerName', sortable: true },
      { text: 'Click', value: 'click', sortable: true },
      { text: 'Susp. Click', value: 'suspiciousClick', sortable: true },
      { text: 'Satış', value: 'sales', sortable: true },
      { text: 'Bekleyen', value: 'expectedEarning', sortable: true },
      { text: 'Kesinleşen', value: 'confirmedEarning', sortable: true },
      { text: 'Payout', value: 'payout', sortable: true },
      { text: 'Oluşturma', value: 'created', sortable: true },
      { text: 'Link', value: 'viewerLink', sortable: false },
    ],
    dashboardWalletHeaders: [
      { text: 'Link / İşlem', value: 'linkName', sortable: true },
      { text: 'Durum', value: 'status', sortable: true },
      { text: 'Kullanıcı görünürlüğü', value: 'userVisible', sortable: true },
      { text: 'Observed', value: 'observedStatus', sortable: true },
      { text: 'Tutar', value: 'amount', sortable: true },
      { text: 'Satış Tutarı', value: 'saleAmount', sortable: true },
      { text: 'Network', value: 'networkSource', sortable: true },
      { text: 'Tarih', value: 'entryDate', sortable: true },
    ],
    dashboardReconciliationHeaders: [
      { text: 'Durum Geçişi', value: 'statusTransition', sortable: false },
      { text: 'Tutar Geçişi', value: 'amountTransition', sortable: false },
      { text: 'Neden', value: 'reason', sortable: true },
      { text: 'Network Gözlemi', value: 'observed', sortable: false },
      { text: 'Eksik Gözlem', value: 'missingObservation', sortable: false },
      { text: 'Bildirim', value: 'notificationStatus', sortable: false },
      { text: 'Sistem Tarihi', value: 'systemAt', sortable: true },
    ],
    dashboardPointHeaders: [
      { text: 'İşlem', value: 'description', sortable: true },
      { text: 'Durum', value: 'status', sortable: true },
      { text: 'Cüzdan', value: 'subWalletType', sortable: true },
      { text: 'Puan', value: 'amount', sortable: true },
      { text: 'TRY Karşılığı', value: 'tryValue', sortable: true },
      { text: 'Bucket', value: 'bucketLabel', sortable: true },
      { text: 'APR', value: 'apr', sortable: true },
      { text: 'Tarih', value: 'effectiveAt', sortable: true },
    ],
    dashboardAnalyticsHeaders: [
      { text: 'Event / Screen', value: 'eventName', sortable: true },
      { text: 'Tip', value: 'eventType', sortable: true },
      { text: 'Target', value: 'target', sortable: false },
      { text: 'Önceki ekran', value: 'previousScreenName', sortable: true },
      { text: 'Platform', value: 'platform', sortable: true },
      { text: 'App', value: 'appVersion', sortable: true },
      { text: 'Properties', value: 'propertiesJson', sortable: false },
      { text: 'Tarih', value: 'occurredAt', sortable: true },
    ],
    dashboardNotificationHeaders: [
      { text: 'Bildirim', value: 'title', sortable: true },
      { text: 'Tip', value: 'type', sortable: true },
      { text: 'Kitle', value: 'audience', sortable: false },
      { text: 'Durum', value: 'send', sortable: true },
      { text: 'Plan', value: 'scheduled', sortable: true },
      { text: 'Link', value: 'linkUniqueId', sortable: true },
      { text: 'Tarih', value: 'date', sortable: true },
    ],
    dashboardMailHeaders: [
      { text: 'ID', value: 'id', width: 80 },
      {
        text: 'Mail', value: 'message', width: 250, sortable: false,
      },
      {
        text: 'Alıcı / Kaynak', value: 'recipient', width: 250, sortable: false,
      },
      { text: 'Provider', value: 'provider', width: 90 },
      { text: 'Durum', value: 'status', width: 150 },
      { text: 'Deneme', value: 'attemptCount', width: 80 },
      { text: 'Oluşturma', value: 'createdAt', width: 165 },
      {
        text: 'Sonuç zamanı', value: 'resultAt', width: 165, sortable: false,
      },
      {
        text: 'Detay', value: 'events', width: 100, sortable: false,
      },
    ],
    dashboardMailEventHeaders: [
      {
        text: 'Event', value: 'event', width: 220, sortable: false,
      },
      { text: 'Durum', value: 'status', width: 150 },
      { text: 'Zaman', value: 'occurredAt', width: 175 },
      { text: 'Hata', value: 'error', sortable: false },
    ],
    dashboardMailRangeOptions: [
      { text: 'Son 7 gün', value: 7 },
      { text: 'Son 30 gün', value: 30 },
      { text: 'Son 90 gün', value: 90 },
      { text: 'Tüm ledger (5 yıl)', value: 1830 },
    ],
    dashboardMailStatusOptions: [
      { text: 'Tüm durumlar', value: '' },
      { text: 'Kabul edildi', value: 'ACCEPTED' },
      { text: 'Teslim edildi', value: 'DELIVERED' },
      { text: 'Bekliyor', value: 'PENDING' },
      { text: 'Gönderiliyor', value: 'IN_FLIGHT' },
      { text: 'Geçici hata', value: 'TEMPORARY_FAILURE' },
      { text: 'Kalıcı hata', value: 'PERMANENT_FAILURE' },
      { text: 'Retry tükendi', value: 'RETRY_EXHAUSTED' },
      { text: 'Belirsiz', value: 'AMBIGUOUS' },
      { text: 'Global hata', value: 'GLOBAL_FAILURE' },
      { text: 'Complaint', value: 'COMPLAINED' },
      { text: 'Suppressed', value: 'SUPPRESSED' },
      { text: 'Unsubscribe', value: 'UNSUBSCRIBED' },
      { text: 'Kayıtlı değil', value: 'UNREGISTERED' },
      { text: 'Atlandı', value: 'SKIPPED' },
    ],
    dashboardWithdrawHeaders: [
      { text: 'Tarih', value: 'requestedAt', sortable: true },
      { text: 'Durum', value: 'status', sortable: true },
      { text: 'Talep', value: 'requestAmount', sortable: true },
      { text: 'Net', value: 'netAmount', sortable: true },
      { text: 'Banka', value: 'bankName', sortable: true },
      { text: 'IBAN', value: 'ibanNumber', sortable: false },
      { text: 'Hata', value: 'failDescription', sortable: false },
    ],
    dashboardBankHeaders: [
      { text: 'Banka', value: 'bankName', sortable: true },
      { text: 'Hesap Adı', value: 'name', sortable: true },
      { text: 'Hesap Sahibi', value: 'accountOwner', sortable: true },
      { text: 'IBAN', value: 'iban', sortable: false },
    ],
    desserts: [],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    menu1: false,
    deleteItems: {},
    userDialog: false,
    rules: {
      counter: value => value.length <= 11 || 'En fazla 11 karakter girilebilmektedir.',
      required: value => !!value || 'Zorunlu.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        return pattern.test(value) || 'Mailinizi doğru girdiğinizden emin olun.'
      },
    },
    icons: {
      mdiDotsVertical,
      mdiPencil,
      mdiDelete,
      mdiEye,
      mdiEyeOff,
      mdiClose,
      mdiRefresh,
    },
    phone: '',
    active: true,
    birthDate: '',
    editedIndex: -1,
    editedItem: {
      name: '',
      surname: '',
      email: '',
      mobile: '',
      birthDate: '',
      password: '',
      gender: false,
      active: true,
    },
    defaultItem: {
      name: '',
      surname: '',
      email: '',
      mobile: '',
      birthDate: '',
      password: '',
      gender: false,
      active: true,
    },
    params: {
      page: 0,
      size: 15,
      sortBy: 'created',
      direction: 'DESC',
      searchKey: '',
      userState: 'ALL',
      reconciliationDeficit: false,
    },
    totalElements: 0,
    userStateOptions: [
      { text: 'Tümü', value: 'ALL' },
      { text: 'Aktif', value: 'ACTIVE' },
      { text: 'Silinmiş', value: 'DELETED' },
    ],
    reconciliationFilterOptions: [
      { text: 'Tüm mutabakat durumları', value: false },
      { text: 'Sadece açığı olanlar', value: true },
    ],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Yeni Kullanıcı' : 'Kullanıcıyı Güncelle'
    },
    dashboardProfile() {
      return (this.dashboard && this.dashboard.profile) || {}
    },
    dashboardWallet() {
      return (this.dashboard && this.dashboard.wallet) || {}
    },
    dashboardPremium() {
      return (this.dashboard && this.dashboard.premium) || {}
    },
    dashboardPoints() {
      return (this.dashboard && this.dashboard.points) || {}
    },
    dashboardInvoiceInfo() {
      return (this.dashboard && this.dashboard.invoiceInfo) || null
    },
    dashboardInterests() {
      return (this.dashboard && this.dashboard.interests) || []
    },
    dashboardPointBucketRows() {
      return (this.dashboard && this.dashboard.pointBuckets) || []
    },
    dashboardPointLockRows() {
      return (this.dashboard && this.dashboard.pointLocks) || []
    },
    dashboardPointAprPreview() {
      return (this.dashboard && this.dashboard.pointAprPreview) || null
    },
    dashboardPointAprTierRows() {
      return (this.dashboardPointAprPreview && this.dashboardPointAprPreview.tier2Recommendations) || []
    },
    dashboardPointDetailCards() {
      return [
        {
          label: 'Toplam puan',
          value: this.formatPoints(this.dashboardPoints.totalPoints, false),
          caption: `${this.formatMoney(this.dashboardPoints.totalTryValue)} karşılığı`,
        },
        {
          label: 'Esnek',
          value: this.formatPoints(this.dashboardPoints.flexiblePoints, false),
          caption: 'Çevrilebilir ana bakiye',
        },
        {
          label: 'Bekleyen',
          value: this.formatPoints(this.dashboardPoints.expectedPoints, false),
          caption: 'Henüz kesinleşmemiş',
        },
        {
          label: 'Kilitli',
          value: this.formatPoints(this.dashboardPoints.lockedPoints, false),
          caption: `${this.dashboardPoints.activeLockCount || 0} aktif kilit`,
        },
        {
          label: 'Ödül',
          value: this.formatPoints(this.dashboardPoints.releasedRewardPoints, false),
          caption: 'Serbestleşmiş ödül puanı',
        },
        {
          label: 'İşlem',
          value: this.dashboardPoints.transactionCount || 0,
          caption: 'Toplam ledger kaydı',
        },
      ]
    },
    dashboardSummaryCards() {
      return [
        {
          label: 'Link',
          value: this.dashboardWallet.linkCount || 0,
          caption: `${this.dashboardLinkRowsCount} kayıt gösteriliyor`,
        },
        {
          label: 'Cüzdan bakiyesi',
          value: this.formatMoney(this.dashboardWallet.availableAmount),
          caption: 'Kesinleşen - çekilen/bekleyen',
        },
        {
          label: 'Bekleyen hakediş',
          value: this.formatMoney(this.dashboardWallet.expectedAmount),
          caption: 'Bekleyen kazanç toplamı',
        },
        {
          label: 'Kesinleşen hakediş',
          value: this.formatMoney(this.dashboardWallet.confirmedAmount),
          caption: 'Kesinleşmiş kazanç toplamı',
        },
        {
          label: 'Mutabakat açığı',
          value: this.formatMoney(this.dashboardWallet.reconciliationDeficitAmount),
          caption: this.dashboardWallet.reconciliationDeficit
            ? 'Yeni para çekimi bloke'
            : 'Açık bulunmuyor',
        },
        {
          label: 'Puan bakiyesi',
          value: this.formatPoints(this.dashboardPoints.totalPoints, false),
          caption: `${this.formatMoney(this.dashboardPoints.totalTryValue)} karşılığı`,
        },
        {
          label: 'Premium',
          value: this.dashboardPremium.accessActive ? 'Aktif' : 'Pasif',
          caption: this.premiumPlanPhaseLabel(this.dashboardPremium),
        },
        {
          label: 'Analytics',
          value: this.dashboardAnalyticsRowsCount,
          caption: 'Son mobil event kayıtları',
        },
        {
          label: 'Bildirim',
          value: this.dashboardNotificationRowsCount,
          caption: 'Kullanıcıya görünür son kayıtlar',
        },
      ]
    },
    dashboardLinkRowsCount() {
      return this.dashboard && this.dashboard.links ? this.dashboard.links.length : 0
    },
    dashboardAnalyticsRowsCount() {
      return this.dashboard && this.dashboard.analyticsEvents ? this.dashboard.analyticsEvents.length : 0
    },
    dashboardNotificationRowsCount() {
      return this.dashboard && this.dashboard.notifications ? this.dashboard.notifications.length : 0
    },
    dashboardProfileRows() {
      return [
        { label: 'Kullanıcı ID', value: this.dashboardProfile.id || '-' },
        { label: 'Ad Soyad', value: this.dashboardProfile.fullName || '-' },
        { label: 'E-posta', value: this.dashboardProfile.email || '-' },
        { label: 'Saklanan e-posta', value: this.dashboardProfile.storedEmail || '-' },
        { label: 'Telefon', value: phoneNumberUtils.display(this.dashboardProfile.mobile) },
        { label: 'Durum', value: this.userStatus(this.dashboardProfile, 'Silinmiş / Pasif').label },
        { label: 'Kayıt tipi', value: this.dashboardProfile.registerType || '-' },
        { label: 'Kayıt tarihi', value: this.formatDateTime(this.dashboardProfile.created) },
        { label: 'Doğum tarihi', value: this.formatDateOnly(this.dashboardProfile.birthDate) },
        { label: 'Cinsiyet', value: this.dashboardProfile.gender || '-' },
        { label: 'E-posta doğrulama', value: this.dashboardProfile.emailVerified ? 'Doğrulandı' : 'Bekliyor / Yok' },
        { label: 'Telefon doğrulama', value: this.dashboardProfile.phoneVerified ? 'Doğrulandı' : 'Yok' },
        { label: 'Mail aboneliği', value: this.dashboardProfile.mailUnsubscribed ? 'Kapalı' : 'Açık' },
        { label: 'Marka ve kampanya mailleri', value: this.formatPreferenceStatus(this.dashboardProfile.brandCampaignMailEnabled) },
        { label: 'Koleksiyon ve fırsat mailleri', value: this.formatPreferenceStatus(this.dashboardProfile.collectionOpportunityMailEnabled) },
        { label: 'Kazanç oranı mailleri', value: this.formatPreferenceStatus(this.dashboardProfile.earningRateMailEnabled) },
        { label: 'KVKK', value: this.dashboardProfile.kvkkAccepted ? 'Kabul edildi' : 'Yok' },
        { label: 'FCM token', value: this.dashboardProfile.fcmTokenPresent ? 'Var' : 'Yok' },
        { label: 'AppsFlyer ID', value: this.dashboardProfile.appsFlyerId || '-' },
        { label: 'Premium paket / faz', value: this.premiumPlanPhaseLabel(this.dashboardPremium) },
        { label: 'Deneme geçmişi', value: this.formatBoolean(this.dashboardPremium.trialUsed) },
        { label: 'Ücretsiz deneme aktif', value: this.formatBoolean(this.dashboardPremium.trialActive) },
        { label: 'Ücretli dönüşüm bekleniyor', value: this.formatBoolean(this.dashboardPremium.trialConversionPending) },
        { label: 'Premium bitiş', value: this.formatTimestamp(this.dashboardPremium.accessEndDate) },
        { label: 'Toplam puan', value: this.formatPoints(this.dashboardPoints.totalPoints, false) },
        { label: 'Esnek puan', value: this.formatPoints(this.dashboardPoints.flexiblePoints, false) },
        { label: 'Bekleyen puan', value: this.formatPoints(this.dashboardPoints.expectedPoints, false) },
        { label: 'Kilitli puan', value: this.formatPoints(this.dashboardPoints.lockedPoints, false) },
        { label: 'Ödül puanı', value: this.formatPoints(this.dashboardPoints.releasedRewardPoints, false) },
      ]
    },
    dashboardPremiumRows() {
      return [
        { label: 'Premium ID', value: this.dashboardPremium.premiumUserId ? `#${this.dashboardPremium.premiumUserId}` : '-' },
        { label: 'Paket / faz', value: this.premiumPlanPhaseLabel(this.dashboardPremium) },
        { label: 'Erişim', value: this.dashboardPremium.accessActive ? 'Aktif' : 'Pasif' },
        { label: 'Durum', value: this.formatDashboardStatus(this.dashboardPremium.accessState) },
        { label: 'Platform', value: this.dashboardPremium.platform || '-' },
        { label: 'Başlangıç', value: this.formatTimestamp(this.dashboardPremium.startDate) },
        { label: 'Bitiş', value: this.formatTimestamp(this.dashboardPremium.accessEndDate) },
        { label: 'Deneme geçmişi', value: this.formatBoolean(this.dashboardPremium.trialUsed) },
        { label: 'Ücretsiz deneme aktif', value: this.formatBoolean(this.dashboardPremium.trialActive) },
        { label: 'Ücretli dönüşüm bekleniyor', value: this.formatBoolean(this.dashboardPremium.trialConversionPending) },
      ]
    },
    dashboardInvoiceRows() {
      if (!this.dashboardInvoiceInfo) return []

      return [
        { label: 'Fatura ID', value: `#${this.dashboardInvoiceInfo.id}` },
        { label: 'Mükellef tipi', value: this.formatInvoiceCompanyType(this.dashboardInvoiceInfo.invoiceTypeCompany) },
        { label: 'Belge tipi', value: this.formatInvoiceType(this.dashboardInvoiceInfo.invoiceType) },
        { label: 'Ad / şirket adı', value: this.dashboardInvoiceInfo.name || '-' },
        { label: 'Soyad', value: this.dashboardInvoiceInfo.surname || '-' },
        { label: 'E-posta', value: this.dashboardInvoiceInfo.emailAddress || '-' },
        { label: 'Vergi dairesi', value: this.dashboardInvoiceInfo.taxOffice || '-' },
        { label: 'Vergi / T.C. no', value: this.dashboardInvoiceInfo.taxNumber || '-' },
        { label: 'IBAN', value: this.dashboardInvoiceInfo.ibanNumber || '-' },
        { label: 'Şehir', value: this.dashboardInvoiceInfo.city || '-' },
        { label: 'İlçe', value: this.dashboardInvoiceInfo.town || '-' },
        { label: 'Adres', value: this.dashboardInvoiceInfo.address || '-' },
        { label: 'Kayıt tarihi', value: this.formatDateTime(this.dashboardInvoiceInfo.created) },
        { label: 'Güncelleme tarihi', value: this.formatDateTime(this.dashboardInvoiceInfo.modified) },
      ]
    },
  },
  watch: {
    '$route.query.userId': 'syncDashboardRoute',
    '$route.query.tab': 'syncDashboardRoute',
    dashboardTab(value) {
      if (!this.dashboardDialog || !this.$route.query.userId || String(value) === this.$route.query.tab) return
      this.$router.replace({ name: 'userList', query: { ...this.$route.query, tab: String(value) } }).catch(() => {})
    },
    dialog(val) {
      if (!val) {
        this.close()
      }
      this.phone = this.editedItem.mobile
    },
    phone(val) {
      this.phone = phoneNumberUtils.formatter(val)
    },
    date() {
      this.editedItem.birthDate = this.formatDate(this.date)
    },
    '$route.query.reconciliationDeficit': function reconciliationDeficitRouteChanged(value) {
      this.params.reconciliationDeficit = value === 'true'
      this.params.page = 0
      this.loadTableData()
    },
  },
  mounted() {
    this.loading = true
  },
  created() {
    this.params.reconciliationDeficit = this.$route.query.reconciliationDeficit === 'true'
    this.loadTableData()
    this.syncDashboardRoute()
  },
  methods: {
    userStatus(user, inactiveLabel = 'Pasif') {
      if (!user.active) return { label: inactiveLabel, color: 'secondary' }
      if (user.emailVerified === false) {
        return { label: 'E-posta doğrulaması bekliyor', color: 'warning' }
      }

      return { label: 'Aktif', color: 'success' }
    },
    displayPhone(value) {
      return phoneNumberUtils.display(value)
    },
    onUpdateTableOptions(options) {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = options
      this.params.page = page > 0 ? page - 1 : 0
      this.params.size = itemsPerPage === -1 ? this.totalElements : itemsPerPage
      this.params.sortBy = this.resolveUserSortField(sortBy[0] || 'created')
      this.params.direction = sortDesc[0] ? 'DESC' : 'ASC'
      this.loadTableData()
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.params.page = 0
        this.params.searchKey = (this.searchValue || '').trim()
        this.loadTableData()
      }, 250)
    },
    onUserStateChange() {
      this.params.page = 0
      this.loadTableData()
    },
    onReconciliationFilterChange() {
      this.params.page = 0
      const query = { ...this.$route.query }
      if (this.params.reconciliationDeficit) {
        query.reconciliationDeficit = 'true'
      } else {
        delete query.reconciliationDeficit
      }
      this.$router.replace({ name: 'userList', query }).catch(() => {})
    },
    closeDialog() {
      this.userDialog = false
    },
    activeChange() {
      this.active = this.editedItem.active
    },
    authHeaders() {
      const token = getAccessToken()

      return token
        ? { Authorization: `Bearer ${token}` }
        : {}
    },
    dashboardTaxDocumentStatusLabel(status) {
      return {
        PENDING_REVIEW: 'İnceleme bekliyor',
        APPROVED: 'Geçerli',
        REJECTED: 'Geçersiz',
      }[status] || status || '-'
    },
    dashboardTaxDocumentStatusColor(status) {
      return {
        PENDING_REVIEW: 'warning',
        APPROVED: 'success',
        REJECTED: 'error',
      }[status] || 'grey'
    },
    formatDashboardTaxDocumentBytes(value) {
      const bytes = Number(value)
      if (!Number.isFinite(bytes) || bytes < 0) return '-'
      if (bytes === 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      const unitIndex = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1)
      const amount = bytes / (1024 ** unitIndex)

      return `${new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 1 }).format(amount)} ${units[unitIndex]}`
    },
    resetDashboardTaxDocumentState() {
      this.dashboardTaxDocumentRequestSerial += 1
      this.dashboardTaxDocumentLoading = false
      this.dashboardTaxDocumentError = ''
      this.dashboardTaxDocument = null
      this.dashboardTaxDocumentPreviewOpen = false
      this.dashboardTaxDocumentReviewLoading = false
      this.dashboardTaxDocumentReviewAction = ''
      this.dashboardTaxDocumentReviewError = ''
      this.dashboardTaxDocumentInvalidDialog = false
      this.dashboardTaxDocumentRejectReason = ''
    },
    loadDashboardTaxDocument() {
      if (!this.dashboardUserId) return Promise.resolve()
      const userId = this.dashboardUserId
      const requestId = this.dashboardTaxDocumentRequestSerial + 1
      this.dashboardTaxDocumentRequestSerial = requestId
      this.dashboardTaxDocumentLoading = true
      this.dashboardTaxDocumentError = ''

      return axios
        .get(`${process.env.VUE_APP_BASE_API_URL}admin/digital-business-documents`, {
          headers: this.authHeaders(),
          params: {
            userId,
            type: 'TAX_EXEMPTION_20B',
            page: 0,
            size: 1,
          },
        })
        .then(response => {
          if (requestId !== this.dashboardTaxDocumentRequestSerial || userId !== this.dashboardUserId) return
          const payload = response?.data?.data || response?.data || {}
          let documents = []
          if (Array.isArray(payload)) documents = payload
          else if (Array.isArray(payload.content)) documents = payload.content
          const newestDocument = documents[0] || null
          this.dashboardTaxDocument = newestDocument?.type === 'TAX_EXEMPTION_20B'
            && newestDocument.current === true
            ? newestDocument
            : null
        })
        .catch(error => {
          if (requestId !== this.dashboardTaxDocumentRequestSerial || userId !== this.dashboardUserId) return
          if (isAuthError(error)) {
            this.$router.push({ name: 'login' })

            return
          }
          this.dashboardTaxDocument = null
          this.dashboardTaxDocumentError = resolveApiErrorMessage(
            error,
            'Kullanıcının 20/B istisna belgesi yüklenemedi.',
          )
        })
        .finally(() => {
          if (requestId === this.dashboardTaxDocumentRequestSerial) {
            this.dashboardTaxDocumentLoading = false
          }
        })
    },
    dashboardTaxDocumentSafeFileName(document) {
      const fallback = `tax-exemption-20b-${document.id || 'document'}`
      const value = Array.from(String(document.originalFileName || fallback))
        .map(character => (character.charCodeAt(0) < 32 ? '_' : character))
        .join('')
        .replace(/[<>:"/\\|?*]/g, '_')
        .trim()

      return value || fallback
    },
    openDashboardTaxDocumentInvalidDialog() {
      if (this.dashboardTaxDocument?.status !== 'PENDING_REVIEW') return
      this.dashboardTaxDocumentRejectReason = ''
      this.dashboardTaxDocumentReviewError = ''
      this.dashboardTaxDocumentInvalidDialog = true
    },
    closeDashboardTaxDocumentInvalidDialog() {
      if (this.dashboardTaxDocumentReviewLoading) return
      this.dashboardTaxDocumentInvalidDialog = false
      this.dashboardTaxDocumentRejectReason = ''
      this.dashboardTaxDocumentReviewError = ''
    },
    async reviewDashboardTaxDocument(decision) {
      const document = this.dashboardTaxDocument
      if (!document?.id || document.status !== 'PENDING_REVIEW' || this.dashboardTaxDocumentReviewLoading) return
      const reason = String(this.dashboardTaxDocumentRejectReason || '').trim()
      if (decision === 'REJECT' && !reason) {
        this.dashboardTaxDocumentReviewError = 'Geçersiz sayma sebebi zorunludur.'

        return
      }
      if (reason.length > 500) {
        this.dashboardTaxDocumentReviewError = 'Geçersiz sayma sebebi en fazla 500 karakter olabilir.'

        return
      }
      this.dashboardTaxDocumentReviewLoading = true
      this.dashboardTaxDocumentReviewAction = decision.toLowerCase()
      this.dashboardTaxDocumentReviewError = ''
      try {
        await axios.post(
          `${process.env.VUE_APP_BASE_API_URL}admin/digital-business-documents/${document.id}/review`,
          {
            decision,
            rejectReason: decision === 'REJECT' ? reason : null,
          },
          { headers: this.authHeaders() },
        )
        this.dashboardTaxDocumentInvalidDialog = false
        this.dashboardTaxDocumentRejectReason = ''
        await this.loadDashboardTaxDocument()
        if (this.dashboardUserId) this.loadUserDashboard(this.dashboardUserId)
      } catch (error) {
        this.dashboardTaxDocumentReviewError = resolveApiErrorMessage(
          error,
          'Belge inceleme kararı kaydedilemedi.',
        )
        if (error?.response?.status === 409) await this.loadDashboardTaxDocument()
      } finally {
        this.dashboardTaxDocumentReviewLoading = false
        this.dashboardTaxDocumentReviewAction = ''
      }
    },
    openUserDashboard(item) {
      if (!item || !item.id) return
      this.$router.push({ name: 'userList', query: { ...this.$route.query, userId: String(item.id), tab: '0' } }).catch(() => {})
    },
    syncDashboardRoute() {
      const raw = this.$route.query.userId
      if (!/^[1-9]\d*$/.test(String(raw || ''))) {
        this.resetUserDashboard()

        return
      }
      const userId = Number(raw)
      if (!Number.isSafeInteger(userId)) return
      const tab = Number(this.$route.query.tab || 0)
      this.dashboardTab = Number.isInteger(tab) && tab >= 0 && tab <= 9 ? tab : 0
      if (this.dashboardUserId === userId && this.dashboardDialog) return
      this.dashboardDialog = true
      this.dashboard = null
      this.dashboardUserId = userId
      this.dashboardError = ''
      this.resetDashboardTaxDocumentState()
      this.resetDashboardMailState()
      this.loadUserDashboard(userId)
      this.loadDashboardTaxDocument()
      this.loadDashboardMails()
    },
    closeUserDashboard() {
      const query = { ...this.$route.query }
      delete query.userId
      delete query.tab
      this.$router.replace({ name: 'userList', query }).catch(() => {})
      this.resetUserDashboard()
    },
    onDashboardVisibility(visible) {
      if (!visible) this.closeUserDashboard()
    },
    resetUserDashboard() {
      this.dashboardRequest += 1
      this.dashboardMailRequest += 1
      this.dashboardDialog = false
      this.dashboardLoading = false
      this.dashboardError = ''
      this.dashboard = null
      this.dashboardUserId = null
      this.resetDashboardTaxDocumentState()
      this.resetDashboardMailState()
    },
    refreshUserDashboard() {
      if (!this.dashboardUserId) return
      this.loadUserDashboard(this.dashboardUserId)
      this.loadDashboardTaxDocument()
      this.loadDashboardMails()
    },
    loadUserDashboard(userId) {
      this.dashboardRequest += 1
      const request = this.dashboardRequest
      this.dashboardLoading = true
      this.dashboardError = ''
      axios
        .get(`${process.env.VUE_APP_BASE_API_URL}panel/users/${userId}/dashboard`, {
          headers: this.authHeaders(),
        })
        .then(response => {
          if (request !== this.dashboardRequest) return
          this.dashboard = response.data && response.data.data ? response.data.data : null
          if (!this.dashboard) {
            this.dashboardError = 'Kullanıcı dashboard verisi boş döndü.'
          }
        })
        .catch(error => {
          if (request !== this.dashboardRequest) return
          if (isAuthError(error)) {
            this.$router.push({ name: 'login' })

            return
          }
          this.dashboardError = resolveApiErrorMessage(error, 'Kullanıcı dashboard yüklenemedi.')
        })
        .finally(() => {
          if (request === this.dashboardRequest) this.dashboardLoading = false
        })
    },
    resetDashboardMailState() {
      this.dashboardMailLoading = false
      this.dashboardMailError = ''
      this.dashboardMails = []
      this.dashboardMailPage = 0
      this.dashboardMailTotal = 0
      this.dashboardMailTotalPages = 0
      this.dashboardMailRangeDays = 90
      this.dashboardMailStatus = ''
      this.closeDashboardMailEvents()
    },
    loadDashboardMails() {
      if (!this.dashboardUserId) return
      this.dashboardMailRequest += 1
      const request = this.dashboardMailRequest
      this.dashboardMailLoading = true
      this.dashboardMailError = ''
      axios
        .get(`${process.env.VUE_APP_BASE_API_URL}admin/analytics/mail/deliveries`, {
          headers: this.authHeaders(),
          params: {
            ...this.dashboardMailDateParams(),
            userId: this.dashboardUserId,
            status: this.dashboardMailStatus || undefined,
            page: this.dashboardMailPage,
            size: this.dashboardMailPageSize,
          },
        })
        .then(response => {
          if (request !== this.dashboardMailRequest) return
          const payload = response?.data?.data || {}
          this.dashboardMails = payload.content || []
          this.dashboardMailTotal = Number(payload.totalElements || 0)
          this.dashboardMailTotalPages = Number(payload.totalPages || 0)
        })
        .catch(error => {
          if (request !== this.dashboardMailRequest) return
          if (isAuthError(error)) {
            this.$router.push({ name: 'login' })

            return
          }
          this.dashboardMails = []
          this.dashboardMailTotal = 0
          this.dashboardMailTotalPages = 0
          this.dashboardMailError = resolveApiErrorMessage(error, 'Kullanıcının mail teslimatları yüklenemedi.')
        })
        .finally(() => {
          if (request === this.dashboardMailRequest) this.dashboardMailLoading = false
        })
    },
    dashboardMailDateParams() {
      const days = Math.max(1, Number(this.dashboardMailRangeDays || 90))
      const millisecondsPerDay = 24 * 60 * 60 * 1000
      const now = new Date()
      const from = new Date(now.getTime() - ((days - 1) * millisecondsPerDay))

      return {
        from: this.formatMailIsoDate(from),
        to: this.formatMailIsoDate(now),
      }
    },
    formatMailIsoDate(value) {
      const parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).formatToParts(value)
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]))

      return `${values.year}-${values.month}-${values.day}`
    },
    applyDashboardMailFilters() {
      this.dashboardMailPage = 0
      this.loadDashboardMails()
    },
    goToDashboardMailPage(page) {
      this.dashboardMailPage = Math.max(0, page)
      this.loadDashboardMails()
    },
    openDashboardMailEvents(item) {
      if (!item || !item.id) return
      this.dashboardSelectedMail = item
      this.dashboardMailEvents = []
      this.dashboardMailEventError = ''
      this.dashboardMailEventDialog = true
      this.dashboardMailEventLoading = true
      axios
        .get(`${process.env.VUE_APP_BASE_API_URL}admin/analytics/mail/deliveries/${item.id}/events`, {
          headers: this.authHeaders(),
        })
        .then(response => {
          this.dashboardMailEvents = response?.data?.data || []
        })
        .catch(error => {
          if (isAuthError(error)) {
            this.$router.push({ name: 'login' })

            return
          }
          this.dashboardMailEventError = resolveApiErrorMessage(error, 'Mail eventleri yüklenemedi.')
        })
        .finally(() => {
          this.dashboardMailEventLoading = false
        })
    },
    closeDashboardMailEvents() {
      this.dashboardMailEventDialog = false
      this.dashboardMailEventLoading = false
      this.dashboardMailEventError = ''
      this.dashboardMailEvents = []
      this.dashboardSelectedMail = null
    },
    loadTableData() {
      this.loading = true
      this.tableError = ''
      axios
        .get(`${process.env.VUE_APP_BASE_API_URL}panel/users`, {
          headers: this.authHeaders(),
          params: this.params,
          paramsSerializer: serializeParams,
        })
        .then(response => {
          this.desserts = (response.data.content || []).map(item => ({
            ...item,
            active: !!item.active,
            gender: this.normalizeBoolean(item.gender),
          }))
          this.totalElements = response.data.totalElements
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          if (isAuthError(error)) {
            this.$router.push({ name: 'login' })

            return
          }

          this.desserts = []
          this.totalElements = 0
          this.tableError = resolveApiErrorMessage(error, 'Kullanıcı listesi yüklenemedi.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    openUserDelete(item) {
      this.userDialog = true
      this.deleteItems = item
    },
    editItem(item) {
      this.editedIndex = item.id
      this.editedItem = {
        ...item,
        gender: this.normalizeBoolean(item.gender),
      }
      this.dialog = true
      this.birthDate = this.editedItem.birthDate
      this.phone = this.editedItem.mobile
    },
    async deleteItem(item) {
      await axios.delete(`${process.env.VUE_APP_BASE_API_URL}panel/users/${item.id}`, { headers: this.authHeaders() })
      this.desserts = this.desserts.filter(userItem => userItem.id !== item.id)
      this.tableError = ''
      this.loadTableData()
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = {
          name: '',
          surname: '',
          email: '',
          mobile: '',
          birthDate: '',
          password: '',
          gender: false,
          active: true,
        }
        this.editedIndex = -1
      }, 300)
    },
    save() {
      if (this.editedIndex > -1) {
        this.phone = this.phone.replace(/\+90/g, '').replace(/\s/g, '')
        axios
          .put(
            `${process.env.VUE_APP_BASE_API_URL}panel/users`,
            {
              id: this.editedItem.id,
              active: this.editedItem.active,
              name: this.editedItem.name,
              surname: this.editedItem.surname,
              email: this.editedItem.email,
              mobile: this.phone,
              birthDate: this.editedItem.birthDate,
              password: this.editedItem.password,
              gender: this.normalizeBoolean(this.editedItem.gender),
            },
            { headers: this.authHeaders() },
          )
          .then(() => {
            this.tableError = ''
            this.loadTableData()
          })
          .catch(error => {
            console.log(error)
            this.tableError = resolveApiErrorMessage(error, 'Kullanıcı güncellenemedi.')
          })
      } else {
        this.phone = this.phone.replace(/\+90/g, '').replace(/\s/g, '')
        axios
          .post(
            `${process.env.VUE_APP_BASE_API_URL}user/public/register`,
            {
              name: this.editedItem.name,
              surname: this.editedItem.surname,
              email: this.editedItem.email,
              mobile: this.phone,
              birthDate:
                this.birthDate !== this.editedItem.birthDate
                  ? this.editedItem.birthDate
                  : this.formatDate(this.editedItem.birthDate),
              password: this.editedItem.password,
              gender: this.normalizeBoolean(this.editedItem.gender),
            },
            { headers: this.authHeaders() },
          )
          .then(() => {
            this.tableError = ''
            this.loadTableData()
          })
          .catch(error => {
            console.log(error)
            this.tableError = resolveApiErrorMessage(error, 'Kullanıcı oluşturulamadı.')
          })
      }
      this.close()
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY')
    },
    formatDateOnly(value) {
      if (!value) return '-'
      const parsed = moment(value)

      return parsed.isValid() ? parsed.format('DD.MM.YYYY') : '-'
    },
    formatDateTime(value) {
      if (!value) return '-'
      const parsed = moment(value)

      return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm') : '-'
    },
    formatMailDateTime(value) {
      if (!value) return '-'
      const parsed = new Date(value)
      if (Number.isNaN(parsed.getTime())) return '-'

      return parsed.toLocaleString('tr-TR', {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    formatMailResultTime(item) {
      if (!item) return '-'
      if (item.deliveredAt) return `Teslim: ${this.formatMailDateTime(item.deliveredAt)}`
      if (item.failedAt) return `Hata: ${this.formatMailDateTime(item.failedAt)}`
      if (item.acceptedAt) return `Kabul: ${this.formatMailDateTime(item.acceptedAt)}`

      return '-'
    },
    formatMailMessageName(value) {
      const labels = {
        password_reset_v2: 'Şifre Sıfırlama',
        email_verification_v2: 'E-posta Doğrulama',
        google_account_link_verification_v2: 'Google Hesabı Bağlama Doğrulaması',
        apple_account_link_verification_v2: 'Apple Hesabı Bağlama Doğrulaması',
        social_account_link_verification_v2: 'Sosyal Hesap Bağlama Doğrulaması',
        account_deletion_verification_v2: 'Hesap Silme Doğrulaması',
        phone_verified_v2: 'Telefon Doğrulandı',
        welcome_v2: 'Hoş Geldin',
        campaign_announcement_v2_new_campaign: 'Yeni Kampanya',
        campaign_announcement_v2_new_collection: 'Yeni Koleksiyon Fırsatı',
        brand_announcement_v2: 'Marka Duyurusu',
        payout_change_v2: 'Ödeme Değişikliği',
        link_created_v2: 'Link Oluşturuldu',
        link_passive_v2: 'Link Pasife Alındı',
        link_completed_v2: 'Link Tamamlandı',
        earning_confirmed_v2: 'Kazanç Onaylandı',
        cashback_confirmed_v2: 'Cashback Onaylandı',
        withdraw_request_v2: 'Para Çekme Talebi',
        withdraw_success_v2: 'Para Çekme Başarılı',
        withdraw_rejected_v2: 'Para Çekme Reddedildi',
        premium_success_v2: 'Premium Başarılı',
        premium_end_v2: 'Premium Sona Erdi',
        new_adverport_announcement_v2: 'Adverport Duyurusu',
        campaign_canary: 'Kampanya Canary',
        unclassified: 'Sınıflandırılmamış',
      }

      return labels[value] || value || '-'
    },
    formatMailSource(value) {
      const labels = {
        CAMPAIGN_ACTIVATION: 'Kampanya',
        TRANSACTIONAL_MAIL: 'Transactional',
        SES_CAMPAIGN_CANARY: 'Canary',
      }

      return labels[value] || value || '-'
    },
    formatMailStatus(value) {
      const labels = {
        PENDING: 'Bekliyor',
        IN_FLIGHT: 'Gönderiliyor',
        AMBIGUOUS: 'Belirsiz',
        ACCEPTED: 'Kabul edildi',
        DELIVERED: 'Teslim edildi',
        TEMPORARY_FAILURE: 'Geçici hata',
        RETRY_EXHAUSTED: 'Retry tükendi',
        PERMANENT_FAILURE: 'Kalıcı hata',
        GLOBAL_FAILURE: 'Global hata',
        SUPPRESSED: 'Suppressed',
        COMPLAINED: 'Complaint',
        UNSUBSCRIBED: 'Unsubscribe',
        UNREGISTERED: 'Kayıtlı değil',
        SKIPPED: 'Atlandı',
      }

      return labels[value] || value || '-'
    },
    mailStatusColor(value) {
      if (value === 'DELIVERED') return 'success'
      if (value === 'ACCEPTED') return 'primary'
      if (['PENDING', 'IN_FLIGHT', 'TEMPORARY_FAILURE'].includes(value)) return 'warning'
      if (['SUPPRESSED', 'UNSUBSCRIBED', 'UNREGISTERED', 'SKIPPED'].includes(value)) return 'grey'
      if (['PERMANENT_FAILURE', 'GLOBAL_FAILURE', 'RETRY_EXHAUSTED', 'AMBIGUOUS', 'COMPLAINED'].includes(value)) return 'error'

      return 'secondary'
    },
    formatMailEventType(value) {
      const labels = {
        SEND: 'Gönderim',
        DELIVERY: 'Teslim',
        OPEN: 'Açılma',
        CLICK: 'Tıklama',
        TRANSIENT_BOUNCE: 'Soft bounce',
        PERMANENT_BOUNCE: 'Hard bounce',
        COMPLAINT: 'Complaint',
        REJECT: 'Reject',
        RENDERING_FAILURE: 'Rendering hatası',
      }

      return labels[value] || value || '-'
    },
    formatTimestamp(value) {
      if (!value) return '-'
      const parsed = moment(Number(value))

      return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm') : '-'
    },
    formatMoney(value) {
      const numericValue = Number(value || 0)

      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number.isFinite(numericValue) ? numericValue : 0)
    },
    formatPoints(value, signed = false) {
      const numericValue = Number(value || 0)
      const safeValue = Number.isFinite(numericValue) ? numericValue : 0
      const prefix = signed && safeValue > 0 ? '+' : ''

      return `${prefix}${new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(safeValue)} ADVp`
    },
    formatApr(value) {
      if (value === null || value === undefined || value === '') return '-'
      const numericValue = Number(value)
      if (!Number.isFinite(numericValue)) return '-'

      return `%${new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(numericValue)}`
    },
    formatAprRange(floor, ceiling) {
      if ((floor === null || floor === undefined || floor === '')
        && (ceiling === null || ceiling === undefined || ceiling === '')) {
        return '-'
      }

      return `${this.formatApr(floor)} - ${this.formatApr(ceiling)}`
    },
    formatPointBucketType(type) {
      const map = {
        FLEXIBLE: 'Esnek',
        EXPECTED: 'Bekleyen',
        LOCKED: 'Kilitli',
        REWARD: 'Ödül',
      }

      return map[type] || type || '-'
    },
    formatPointAccessTier(tier) {
      const map = {
        PREMIUM: 'Premium',
        STANDARD: 'Standart',
      }

      return map[tier] || tier || '-'
    },
    formatPointTransactionIdentity(item) {
      if (!item) return '-'

      return item.transactionIdentity || item.referenceId || (item.id ? `point:${item.id}` : '-')
    },
    formatPayout(value, type) {
      if (value === null || value === undefined || value === '') return '-'
      const normalizedType = String(type || '').toLowerCase()

      if (normalizedType.includes('percent')) {
        return this.formatApr(value)
      }

      return this.formatMoney(value)
    },
    formatBoolean(value) {
      return value ? 'Evet' : 'Hayır'
    },
    premiumPlanPhaseLabel(item) {
      const plan = item?.packageName || item?.accessState || '-'
      if (item?.trialActive) return `${plan} · 3 günlük ücretsiz deneme aktif`
      if (item?.trialConversionPending) return `${plan} · ücretli dönüşüm bekleniyor`

      return plan
    },
    formatPreferenceStatus(value) {
      if (value === null || value === undefined) return '-'

      return value ? 'Açık' : 'Kapalı'
    },
    formatTaxValues(values) {
      if (!values || typeof values !== 'object') return '-'
      const rows = Object.entries(values)
        .filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${key}: ${this.formatMoney(value)}`)

      return rows.length ? rows.join(' · ') : '-'
    },
    dashboardWalletDetailRows(item) {
      return walletTransactionDetailRows(item, this)
    },
    dashboardWithdrawDetailRows(item) {
      if (!item) return []

      return [
        { label: 'Talep ID', value: item.id ? `#${item.id}` : '-' },
        { label: 'Talep Tarihi', value: this.formatDateTime(item.requestedAt) },
        { label: 'Durum', value: this.formatDashboardStatus(item.status) },
        { label: 'Vergi Hariç Tutar', value: this.formatMoney(item.requestAmount) },
        { label: 'Vergi', value: this.formatMoney(item.taxAmount) },
        { label: 'Toplam Transfer Tutarı', value: this.formatMoney(item.netAmount) },
        { label: 'Önceki Bakiye', value: this.formatMoney(item.previousBalance) },
        { label: 'Banka', value: item.bankName || '-' },
        { label: 'IBAN', value: item.ibanNumber || '-' },
        { label: 'Fatura', value: this.formatBoolean(item.invoice) },
        { label: 'Panel Fatura', value: this.formatBoolean(item.panelInvoice) },
        { label: 'Onay', value: this.formatBoolean(item.accept) },
        { label: 'Fatura Şirket Tipi', value: item.invoiceTypeCompany || '-' },
        { label: 'Fatura Tipi', value: item.invoiceType || '-' },
        { label: 'Ad Soyad', value: [item.name, item.surname].filter(Boolean).join(' ') || '-' },
        { label: 'E-posta', value: item.emailAddress || '-' },
        { label: 'Vergi Dairesi', value: item.taxOffice || '-' },
        { label: 'Vergi No', value: item.taxNumber || '-' },
        { label: 'Şehir / İlçe', value: [item.city, item.town].filter(Boolean).join(' / ') || '-' },
        { label: 'Adres', value: item.address || '-' },
        { label: 'Vergi Kırılımı', value: this.formatTaxValues(item.taxValues) },
        { label: 'Hata Açıklaması', value: item.failDescription || '-' },
      ]
    },
    formatAnalyticsTarget(item) {
      const parts = [item.targetType, item.targetId].filter(Boolean)

      return parts.length ? parts.join(' / ') : '-'
    },
    formatNotificationAudience(item) {
      if (item.allUsers) return 'Tüm kullanıcılar'
      if (item.topic) return item.topic

      return 'Kullanıcı'
    },
    formatInvoiceCompanyType(value) {
      return {
        PERSONAL: 'Şahıs şirketi',
        COMPANY: 'LTD. / A.Ş.',
        NONE: 'Yok',
      }[value] || value || '-'
    },
    formatInvoiceType(value) {
      return {
        INVOICE: 'Fatura',
        RECEIPT: 'Makbuz',
        SELF_EMPLOYMENT: 'Serbest meslek makbuzu',
        EXPENSE_COMPASS: 'Gider pusulası',
        CUSTOM_BANK: 'Özel banka',
      }[value] || value || '-'
    },
    formatJsonPreview(value) {
      if (!value) return '-'
      const rawValue = String(value)

      return rawValue.length > 140 ? `${rawValue.slice(0, 140)}...` : rawValue
    },
    analyticsTypeColor(type) {
      const map = {
        SCREEN_VIEW: 'info',
        CTA_CLICK: 'primary',
        BUSINESS_SUCCESS: 'success',
        FORM_SUBMIT: 'warning',
        MODAL_VIEW: 'secondary',
      }

      return map[type] || 'secondary'
    },
    formatDashboardStatus(status) {
      const map = {
        ACTIVE: 'Aktif',
        PASSIVE: 'Pasif',
        COMPLETED: 'Tamamlanmış',
        EXPECTED: 'Bekleyen',
        CONFIRMED: 'Kesinleşen',
        CANCELLED: 'İptal',
        PENDING: 'Beklemede',
        SUCCESS: 'Başarılı',
        FAILED: 'Başarısız',
        POSTED: 'İşlendi',
        REVERSED: 'Geri Alındı',
      }

      return map[status] || status || '-'
    },
    formatReconciliationReason(reason) {
      const map = {
        NETWORK_OBSERVED: 'Networkte görüldü',
        NETWORK_STATUS_UPDATED: 'Network durumu güncellendi',
        NETWORK_REJECTED: 'Network reddetti',
        NETWORK_MISSING: 'Network raporunda kayboldu',
        NETWORK_RESTORED: 'Networkte yeniden göründü',
        AMOUNT_ZERO: 'Tutar sıfırlandı',
        AMOUNT_UPDATED: 'Tutar güncellendi',
        AUTO_CONFIRMED_45_DAYS: 'Kesinleşme süresi doldu',
      }

      return map[reason] || reason || '-'
    },
    formatNotificationDispatchStatus(status) {
      return {
        QUEUED: 'Gönderim kuyruğuna alındı',
        SENT: 'Gönderildi',
        FAILED: 'Gönderilemedi',
        SKIPPED: 'Gönderilmedi',
      }[status] || status || '-'
    },
    dashboardStatusColor(status) {
      const map = {
        ACTIVE: 'success',
        CONFIRMED: 'success',
        SUCCESS: 'success',
        PASSIVE: 'warning',
        PENDING: 'warning',
        EXPECTED: 'warning',
        COMPLETED: 'secondary',
        CANCELLED: 'primary',
        FAILED: 'primary',
        POSTED: 'success',
        REVERSED: 'primary',
      }

      return map[status] || 'secondary'
    },
    normalizeBoolean(value) {
      if (value === true || value === 'true' || value === 1 || value === '1') return true
      if (value === false || value === 'false' || value === 0 || value === '0') return false

      return false
    },
    resolveUserSortField(sortBy) {
      const map = {
        registerDate: 'created',
      }

      return map[sortBy] || sortBy || 'created'
    },
    getInitials(item) {
      return [item?.name, item?.surname]
        .filter(Boolean)
        .map(part => part.charAt(0))
        .join('')
        .slice(0, 2)
        .toUpperCase()
    },
    handleSave(item) {
      this.save(item)
    },
  },
}
</script>

<style scoped>
.user-list-toolbar {
  row-gap: 12px;
}

.user-list-toolbar__meta,
.user-list-toolbar__controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  min-width: 0;
}

.user-list-toolbar__meta {
  flex: 0 1 auto;
}

.user-list-toolbar__controls {
  flex: 1 1 760px;
  justify-content: flex-end;
}

.user-list-search {
  flex: 1 1 360px;
  max-width: 420px;
  min-width: 280px;
}

.user-list-filter {
  flex: 0 0 180px;
  max-width: 190px;
  min-width: 170px;
}

.user-list-note {
  max-width: 100%;
  white-space: normal !important;
  text-align: left;
}

.user-list-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-list-user__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-list-user__copy strong {
  line-height: 1.3;
}

.user-list-user__copy span,
.user-list-email {
  font-size: 12px;
  opacity: 0.72;
}

.admin-data-table ::v-deep tbody tr {
  cursor: pointer;
}

.user-dashboard-dialog-shell {
  margin: 0 !important;
}

.user-dashboard-dialog--full {
  border-radius: 0 !important;
  min-height: 100vh;
}

.user-dashboard-dialog__body {
  padding: 24px !important;
  background: var(--admin-canvas);
}

.user-dashboard-title {
  display: flex;
  align-items: center;
  min-width: 0;
}

.user-dashboard-title__meta {
  color: #8a8d99;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 2px;
}

.user-dashboard-summary-grid,
.user-dashboard-profile-grid {
  display: grid;
  gap: 14px;
}

.user-dashboard-summary-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-bottom: 18px;
}

.user-dashboard-summary-card,
.user-dashboard-profile-item {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 6px;
  box-shadow: none;
}

.user-dashboard-summary-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 76px;
  padding: 12px;
  border: 0;
  border-bottom: 1px solid var(--admin-border);
  border-radius: 0;
  background: transparent;
}

.user-dashboard-summary-card span,
.user-dashboard-profile-item span {
  color: #545965;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.user-dashboard-summary-card strong {
  color: var(--admin-text);
  font-size: 24px;
  line-height: 1.2;
}

.user-dashboard-summary-card small {
  color: #545965;
  line-height: 1.35;
}

.user-dashboard-point-overview,
.user-dashboard-apr-cards {
  display: grid;
  gap: 12px;
}

.user-dashboard-point-overview {
  grid-template-columns: repeat(6, minmax(0, 1fr));
  margin-bottom: 16px;
}

.user-dashboard-point-card,
.user-dashboard-apr-card,
.user-dashboard-point-section {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 16px;
  box-shadow: 0 10px 26px rgba(20, 24, 40, 0.04);
}

.user-dashboard-point-card,
.user-dashboard-apr-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 104px;
  padding: 16px;
}

.user-dashboard-point-card span,
.user-dashboard-apr-card span {
  color: #8a8d99;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.user-dashboard-point-card strong,
.user-dashboard-apr-card strong {
  color: #15192b;
  font-size: 22px;
  line-height: 1.2;
}

.user-dashboard-point-card small,
.user-dashboard-apr-card small {
  color: #8a8d99;
  line-height: 1.35;
}

.user-dashboard-point-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  margin-bottom: 16px;
}

.user-dashboard-point-section {
  overflow: hidden;
}

.user-dashboard-point-section--locks {
  margin-bottom: 16px;
}

.user-dashboard-point-section__header {
  align-items: center;
  border-bottom: 1px solid rgba(20, 24, 40, 0.08);
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
}

.user-dashboard-point-section__header h3 {
  color: #15192b;
  font-size: 15px;
  font-weight: 800;
  margin: 0;
}

.user-dashboard-point-section__header span {
  color: #8a8d99;
  font-size: 12px;
  font-weight: 700;
}

.user-dashboard-apr-cards {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 14px 16px 8px;
}

.user-dashboard-apr-summary {
  color: #6f7482;
  font-size: 13px;
  line-height: 1.45;
  margin: 4px 16px 12px;
}

.user-dashboard-apr-notes {
  border-top: 1px solid rgba(20, 24, 40, 0.08);
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 12px 16px 14px;
}

.user-dashboard-apr-notes strong {
  color: #15192b;
  font-size: 12px;
}

.user-dashboard-apr-notes span {
  color: #8a8d99;
  font-size: 12px;
}

.user-dashboard-point-simple-table ::v-deep th,
.user-dashboard-point-simple-table ::v-deep td {
  white-space: nowrap;
}

.user-dashboard-tabs {
  background: transparent;
  margin-bottom: 14px;
}

.user-dashboard-mail-toolbar,
.user-dashboard-mail-pagination {
  align-items: center;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.user-dashboard-mail-toolbar {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-bottom: 0;
  border-radius: 16px 16px 0 0;
  padding: 14px 16px;
}

.user-dashboard-mail-filter {
  flex: 0 1 240px;
  max-width: 260px;
}

.user-dashboard-mail-pagination {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 0 0 16px 16px;
  border-top: 0;
  justify-content: space-between;
  padding: 14px 16px;
}

.user-dashboard-mail-recipient,
.user-dashboard-mail-error {
  display: flex;
  flex-direction: column;
  gap: 3px;
  max-width: 280px;
  overflow-wrap: anywhere;
}

.user-dashboard-mail-recipient span,
.user-dashboard-mail-error span {
  color: #8a8d99;
  font-size: 12px;
}

.user-dashboard-table,
.user-dashboard-profile-grid {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 16px;
  overflow: hidden;
}

.user-dashboard-primary-cell {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 180px;
}

.user-dashboard-primary-cell span {
  color: #8a8d99;
  font-size: 12px;
}

.user-dashboard-primary-cell .user-dashboard-self-link-chip {
  align-self: flex-start;
  color: var(--v-primary-base) !important;
  font-size: 10px;
  margin-top: 2px;
}

.user-dashboard-link-expanded {
  background: var(--admin-canvas);
  padding: 0 !important;
}

.user-dashboard-link-detail {
  padding: 18px 22px 20px;
}

.user-dashboard-link-detail-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-bottom: 16px;
}

.user-dashboard-link-detail-card {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 12px;
  padding: 12px;
}

.user-dashboard-link-detail-card span {
  color: #8a8d99;
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.user-dashboard-link-detail-card strong {
  color: #15192b;
  font-size: 14px;
}

.user-dashboard-detail-panel {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 18px 22px 20px;
}

.user-dashboard-detail-panel--wide {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.user-dashboard-detail-item {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 12px;
  padding: 12px;
}

.user-dashboard-detail-item span {
  color: #8a8d99;
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.user-dashboard-detail-item strong {
  color: #15192b;
  display: block;
  font-size: 13px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.user-dashboard-link-transactions-title {
  color: #15192b;
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 8px;
}

.user-dashboard-link-transactions {
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 12px;
  overflow: hidden;
}

.user-dashboard-empty-note {
  color: #8a8d99;
  font-size: 13px;
  padding: 8px 0 2px;
}

.user-dashboard-json-preview {
  color: #6f7482;
  display: inline-block;
  font-size: 12px;
  max-width: 280px;
  overflow-wrap: anywhere;
}

.user-dashboard-profile-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 18px;
  padding: 14px;
}

.user-dashboard-profile-grid--section {
  margin-bottom: 0;
}

.user-dashboard-profile-item {
  box-shadow: none;
  padding: 14px;
}

.user-dashboard-profile-item strong {
  color: #15192b;
  display: block;
  font-size: 14px;
  line-height: 1.4;
  margin-top: 6px;
  overflow-wrap: anywhere;
}

.user-dashboard-section-title {
  color: #15192b;
  font-size: 16px;
  margin: 20px 0 12px;
}

.user-dashboard-interests,
.user-dashboard-profile-empty {
  background: var(--admin-surface);
  border: 1px solid rgba(20, 24, 40, 0.08);
  border-radius: 16px;
  margin-bottom: 18px;
  padding: 16px;
}

.user-dashboard-interests {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.user-dashboard-profile-empty {
  color: #8a8d99;
  font-size: 13px;
}

@media (max-width: 1360px) {
  .user-list-toolbar__controls {
    width: 100%;
    justify-content: flex-start;
  }

  .user-list-search {
    max-width: none;
  }

  .user-dashboard-summary-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .user-dashboard-point-overview {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .user-dashboard-point-grid {
    grid-template-columns: 1fr;
  }

  .user-dashboard-link-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .user-dashboard-detail-panel,
  .user-dashboard-detail-panel--wide {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 960px) {
  .user-list-search,
  .user-list-filter,
  .user-list-note {
    width: 100%;
    max-width: none;
  }

  .user-dashboard-point-overview,
  .user-dashboard-apr-cards,
  .user-dashboard-profile-grid,
  .user-dashboard-link-detail-grid,
  .user-dashboard-point-grid,
  .user-dashboard-detail-panel,
  .user-dashboard-detail-panel--wide {
    grid-template-columns: 1fr;
  }
  .user-dashboard-summary-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px 12px; }
  .user-dashboard-summary-card { padding: 8px 0; min-height: 72px; }
  .user-dashboard-summary-card strong { font-size: 19px; overflow-wrap: anywhere; }
}
.theme--dark .user-dashboard-summary-card span,
.theme--dark .user-dashboard-summary-card small { color: #c6c9d0; }
.theme--dark .user-dashboard-dialog__body strong,
.theme--dark .user-dashboard-point-section-title,
.theme--dark .user-dashboard-section-title,
.theme--dark .user-dashboard-link-transactions-title { color: var(--admin-text); }
</style>
